import { isEmpty, isEmptyString } from "../gui_components/Util.js";
export class SecurityAccessManager {
  static entitlements = [];

  static initEntitlements() {
    let lsEntitlements = JSON.parse(localStorage.getItem("entitlements"));
    lsEntitlements.map((line) => {
      let exisitingEntitlement = this.entitlements[line.code]; // Multiple Roles
      if (isEmpty(exisitingEntitlement)) this.entitlements[line.code] = line;
    });
  }
  static isAccessible(entitlementCode) {
    let isAccessibleEntitlement = false;
    if (!isEmptyString(entitlementCode)) {
      let entitlementBean = this.entitlements[entitlementCode];
      if (entitlementBean !== null && entitlementBean !== undefined)
        isAccessibleEntitlement = true;
    }
    return isAccessibleEntitlement;
  }
  //#region DashBoard
  static DashBoardMaintenance_IsAccessible() {
    return this.isAccessible("DAS00");
  }
  static DashBoardView_IsAccessible() {
    return this.isAccessible("DAS01");
  }
  //#endregion
  //#region attribute
  //#region general
  //#region BusinessDivision Attribute
  static BusinessDivisionMaintenance_IsAccessible() {
    return this.isAccessible("MBDIV00");
  }
  static BusinessDivisionMaintenanceCreate_IsAccessible() {
    return this.isAccessible("MBDIV01");
  }
  static BusinessDivisionMaintenanceEdit_IsAccessible() {
    return this.isAccessible("MBDIV02");
  }
  static BusinessDivisionMaintenanceView_IsAccessible() {
    return this.isAccessible("MBDIV03");
  }
  static BusinessDivisionMaintenanceDelete_IsAccessible() {
    return this.isAccessible("MBDIV04");
  }
  //#endregion
  //#region UOM Attribute
  static UomMaintenance_IsAccessible() {
    return this.isAccessible("M1000");
  }
  static UomMaintenanceCreate_IsAccessible() {
    return this.isAccessible("M1001");
  }
  static UomMaintenanceEdit_IsAccessible() {
    return this.isAccessible("M1002");
  }
  static UomMaintenanceView_IsAccessible() {
    return this.isAccessible("M1003");
  }
  static UomMaintenanceDelete_IsAccessible() {
    return this.isAccessible("M1004");
  }
  //#endregion
  //#region Currency Attrbute
  static CurrencyMaintanance_IsAccessible() {
    return this.isAccessible("M1140");
  }
  static CurrencyMaintananceCreate_IsAccessible() {
    return this.isAccessible("M1141");
  }
  static CurrencyMaintananceEdit_IsAccessible() {
    return this.isAccessible("M1142");
  }
  static CurrencyMaintananceView_IsAccessible() {
    return this.isAccessible("M1143");
  }
  static CurrencyMaintananceDelete_IsAccessible() {
    return this.isAccessible("M1144");
  }
  //#endregion
  //#region Style Attribute
  static ProductTypeMaintenance_IsAccessible() {
    return this.isAccessible("M1210");
  }
  static ProductTypeMaintenanceCreate_IsAccessible() {
    return this.isAccessible("M1211");
  }
  static ProductTypeMaintenanceEdit_IsAccessible() {
    return this.isAccessible("M1212");
  }
  static ProductTypeMaintenanceView_IsAccessible() {
    return this.isAccessible("M1213");
  }
  static ProductTypeMaintenanceDelete_IsAccessible() {
    return this.isAccessible("M1214");
  }
  //#endregion
  //#region StyleType Attribute
  //#region PatternType Attribute
  static PatternTypeMaintenance_IsAccessible() {
    return this.isAccessible("M1220");
  }
  static PatternTypeMaintenanceCreate_IsAccessible() {
    return this.isAccessible("M1221");
  }
  static PatternTypeMaintenanceEdit_IsAccessible() {
    return this.isAccessible("M1222");
  }
  static PatternTypeMaintenanceView_IsAccessible() {
    return this.isAccessible("M1223");
  }
  static PatternTypeMaintenanceDelete_IsAccessible() {
    return this.isAccessible("M1224");
  }
  //#endregion
  //#region TypeCategory Attribute
  static TypeCategoryMaintenance_IsAccessible() {
    return this.isAccessible("MTYCT00");
  }
  static TypeCategoryMaintenanceCreate_IsAccessible() {
    return this.isAccessible("MTYCT01");
  }
  static TypeCategoryMaintenanceEdit_IsAccessible() {
    return this.isAccessible("MTYCT02");
  }
  static TypeCategoryMaintenanceView_IsAccessible() {
    return this.isAccessible("MTYCT03");
  }
  static TypeCategoryMaintenanceDelete_IsAccessible() {
    return this.isAccessible("MTYCT04");
  }
  //#endregion
  //#region Content Attribute
  static MakeTypeMaintenance_IsAccessible() {
    return this.isAccessible("M1230");
  }
  static MakeTypeMaintenanceCreate_IsAccessible() {
    return this.isAccessible("M1231");
  }
  static MakeTypeMaintenanceEdit_IsAccessible() {
    return this.isAccessible("M1232");
  }
  static MakeTypeMaintenanceView_IsAccessible() {
    return this.isAccessible("M1233");
  }
  static MakeTypeMaintenanceDelete_IsAccessible() {
    return this.isAccessible("M1234");
  }
  //#endregion
  //#region ProductDivision Attribute
  static ProductDivisionMaintenance_IsAccessible() {
    return this.isAccessible("M1020");
  }
  static ProductDivisionMaintenanceCreate_IsAccessible() {
    return this.isAccessible("M1021");
  }
  static ProductDivisionMaintenanceEdit_IsAccessible() {
    return this.isAccessible("M1022");
  }
  static ProductDivisionMaintenanceView_IsAccessible() {
    return this.isAccessible("M1023");
  }
  static ProductDivisionMaintenanceDelete_IsAccessible() {
    return this.isAccessible("M1024");
  }
  //#endregion
  //#region Color Attribute
  static ColorMaintenance_IsAccessible() {
    return this.isAccessible("M6000");
  }
  static ColorMaintenanceCreate_IsAccessible() {
    return this.isAccessible("M6001");
  }
  static ColorMaintenanceEdit_IsAccessible() {
    return this.isAccessible("M6002");
  }
  static ColorMaintenanceView_IsAccessible() {
    return this.isAccessible("M6003");
  }
  static ColorMaintenanceDelete_IsAccessible() {
    return this.isAccessible("M6004");
  }
  //#endregion
  //#region CompositionType Attribute
  static CompositionTypeMaintenance_IsAccessible() {
    return this.isAccessible("M6010");
  }
  static CompositionTypeMaintenanceCreate_IsAccessible() {
    return this.isAccessible("M6011");
  }
  static CompositionTypeMaintenanceEdit_IsAccessible() {
    return this.isAccessible("M6012");
  }
  static CompositionTypeMaintenanceView_IsAccessible() {
    return this.isAccessible("M6013");
  }
  static CompositionTypeMaintenanceDelete_IsAccessible() {
    return this.isAccessible("M6014");
  }
  //#endregion
  //#region StyleItemType Attribute
  static StyleItemTypeMaintenance_IsAccessible() {
    return this.isAccessible("MSIT00");
  }
  static StyleItemTypeMaintenanceCreate_IsAccessible() {
    return this.isAccessible("MSIT01");
  }
  static StyleItemTypeMaintenanceEdit_IsAccessible() {
    return this.isAccessible("MSIT02");
  }
  static StyleItemTypeMaintenanceView_IsAccessible() {
    return this.isAccessible("MSIT03");
  }
  static StyleItemTypeMaintenanceDelete_IsAccessible() {
    return this.isAccessible("MSIT04");
  }
  //#endregion
  //#region Country Attribute
  static CountryMaintenance_IsAccessible() {
    return this.isAccessible("M6020");
  }
  static CountryMaintenanceCreate_IsAccessible() {
    return this.isAccessible("M6021");
  }
  static CountryMaintenanceEdit_IsAccessible() {
    return this.isAccessible("M6022");
  }
  static CountryMaintenanceView_IsAccessible() {
    return this.isAccessible("M6023");
  }
  static CountryMaintenanceDelete_IsAccessible() {
    return this.isAccessible("M6024");
  }
  //#endregion
  //#region Season Attribute
  static SeasonMaintenance_IsAccessible() {
    return this.isAccessible("M1110");
  }
  static SeasonMaintenanceCreate_IsAccessible() {
    return this.isAccessible("M1111");
  }
  static SeasonMaintenanceEdit_IsAccessible() {
    return this.isAccessible("M1112");
  }
  static SeasonMaintenanceView_IsAccessible() {
    return this.isAccessible("M1113");
  }
  static SeasonMaintenanceDelete_IsAccessible() {
    return this.isAccessible("M1114");
  }
  //#endregion
  //#region Location Attribute
  static LocationMaintenance_IsAccessible() {
    return this.isAccessible("M1300");
  }
  static LocationMaintenanceCreate_IsAccessible() {
    return this.isAccessible("M1301");
  }
  static LocationMaintenanceEdit_IsAccessible() {
    return this.isAccessible("M1302");
  }
  static LocationMaintenanceView_IsAccessible() {
    return this.isAccessible("M1303");
  }
  static LocationMaintenanceDelete_IsAccessible() {
    return this.isAccessible("M1304");
  }
  //#endregion
  //#region Bin Location
  static BinLocationMaintenance_IsAccessible() {
    return this.isAccessible("M9004");
  }
  static BinLocationCreate_IsAccessible() {
    return this.isAccessible("M9005");
  }
  static BinLocationEdit_IsAccessible() {
    return this.isAccessible("M9006");
  }
  static BinLocationView_IsAccessible() {
    return this.isAccessible("M9007");
  }
  static BinLocationDelete_IsAccessible() {
    return this.isAccessible("M9008");
  }
  //#endregion
  //#region RoyaltyClient Attribute
  static RoyaltyClientMaintenance_IsAccessible() {
    return this.isAccessible("M6030");
  }
  static RoyaltyClientMaintenanceCreate_IsAccessible() {
    return this.isAccessible("M6031");
  }
  static RoyaltyClientMaintenanceEdit_IsAccessible() {
    return this.isAccessible("M6032");
  }
  static RoyaltyClientMaintenanceView_IsAccessible() {
    return this.isAccessible("M6033");
  }
  static RoyaltyClientMaintenanceDelete_IsAccessible() {
    return this.isAccessible("M6034");
  }
  //#endregion
  //#region InventoryAdjustment Attribute
  static InventoryAdjustmentReasonMaintenance_IsAccessible() {
    return this.isAccessible("M6040");
  }
  static InventoryAdjustmentReasonMaintenanceCreate_IsAccessible() {
    return this.isAccessible("M6041");
  }
  static InventoryAdjustmentReasonMaintenanceEdit_IsAccessible() {
    return this.isAccessible("M6042");
  }
  static InventoryAdjustmentReasonMaintenanceView_IsAccessible() {
    return this.isAccessible("M6043");
  }
  static InventoryAdjustmentReasonMaintenanceDelete_IsAccessible() {
    return this.isAccessible("M6044");
  }
  //#endregion
  //#region CurrencyExchangeRate Attribute
  static CurrencyExchangeRateMaintenance_IsAccessible() {
    return this.isAccessible("M6050");
  }
  static CurrencyExchangeRateMaintenanceCreate_IsAccessible() {
    return this.isAccessible("M6051");
  }
  static CurrencyExchangeRateMaintenanceEdit_IsAccessible() {
    return this.isAccessible("M6052");
  }
  static CurrencyExchangeRateMaintenanceView_IsAccessible() {
    return this.isAccessible("M6053");
  }
  static CurrencyExchangeRateMaintenanceDelete_IsAccessible() {
    return this.isAccessible("M6054");
  }
  //#endregion
  //#region Employee Attrbute
  static EmployeeMaintanance_IsAccessible() {
    return this.isAccessible("M1010");
  }
  static EmployeeMaintananceCreate_IsAccessible() {
    return this.isAccessible("M1011");
  }
  static EmployeeMaintananceEdit_IsAccessible() {
    return this.isAccessible("M1012");
  }
  static EmployeeMaintananceView_IsAccessible() {
    return this.isAccessible("M1013");
  }
  static EmployeeMaintananceDelete_IsAccessible() {
    return this.isAccessible("M1014");
  }
  //#endregion
  //#region HarmonizedTariffSchedule Attribute
  static HarmonizedTariffScheduleMaintenance_IsAccessible() {
    return this.isAccessible("M6635");
  }
  static HarmonizedTariffScheduleMaintenanceCreate_IsAccessible() {
    return this.isAccessible("M6636");
  }
  static HarmonizedTariffScheduleMaintenanceEdit_IsAccessible() {
    return this.isAccessible("M6637");
  }
  static HarmonizedTariffScheduleMaintenanceView_IsAccessible() {
    return this.isAccessible("M6638");
  }
  static HarmonizedTariffScheduleMaintenanceDelete_IsAccessible() {
    return this.isAccessible("M6639");
  }
  //#endregion
  //#region ProductStatus Attribute
  static ProductStatusMaintenance_IsAccessible() {
    return this.isAccessible("M6630");
  }
  static ProductStatusMaintenanceCreate_IsAccessible() {
    return this.isAccessible("M6631");
  }
  static ProductStatusMaintenanceEdit_IsAccessible() {
    return this.isAccessible("M6632");
  }
  static ProductStatusMaintenanceView_IsAccessible() {
    return this.isAccessible("M6633");
  }
  static ProductStatusMaintenanceDelete_IsAccessible() {
    return this.isAccessible("M6634");
  }
  //#endregion
  //#region FabricVendorMiscellaneousCostDetail Attribute
  static FabricVendorMiscellaneousCostDetailMaintenance_IsAccessible() {
    return this.isAccessible("MFMSCT00");
  }
  static FabricVendorMiscellaneousCostDetailMaintenanceCreate_IsAccessible() {
    return this.isAccessible("MFMSCT01");
  }
  static FabricVendorMiscellaneousCostDetailMaintenanceEdit_IsAccessible() {
    return this.isAccessible("MFMSCT02");
  }
  static FabricVendorMiscellaneousCostDetailMaintenanceView_IsAccessible() {
    return this.isAccessible("MFMSCT03");
  }
  static FabricVendorMiscellaneousCostDetailMaintenanceDelete_IsAccessible() {
    return this.isAccessible("MFMSCT04");
  }
  //#endregion
  //#region FiscalYear Attribute
  static FiscalYearMaintenance_IsAccessible() {
    return this.isAccessible("MFSYR00");
  }
  static FiscalYearMaintenanceCreate_IsAccessible() {
    return this.isAccessible("MFSYR01");
  }
  static FiscalYearMaintenanceEdit_IsAccessible() {
    return this.isAccessible("MFSYR02");
  }
  static FiscalYearMaintenanceView_IsAccessible() {
    return this.isAccessible("MFSYR03");
  }
  static FiscalYearMaintenanceDelete_IsAccessible() {
    return this.isAccessible("MFSYR04");
  }
  //#endregion
  //#region Comment Attribute
  static CommentMaintenance_IsAccessible() {
    return this.isAccessible("MCMT00");
  }
  static CommentMaintenanceCreate_IsAccessible() {
    return this.isAccessible("MCMT01");
  }
  static CommentMaintenanceEdit_IsAccessible() {
    return this.isAccessible("MCMT02");
  }
  static CommentMaintenanceView_IsAccessible() {
    return this.isAccessible("MCMT03");
  }
  static CommentMaintenanceDelete_IsAccessible() {
    return this.isAccessible("MCMT04");
  }
  //#endregion
  //#region ShipTo Attribute
  static ShipToMaintenance_IsAccessible() {
    return this.isAccessible("MSHPT00");
  }
  static ShipToMaintenanceCreate_IsAccessible() {
    return this.isAccessible("MSHPT01");
  }
  static ShipToMaintenanceEdit_IsAccessible() {
    return this.isAccessible("MSHPT02");
  }
  static ShipToMaintenanceView_IsAccessible() {
    return this.isAccessible("MSHPT03");
  }
  static ShipToMaintenanceDelete_IsAccessible() {
    return this.isAccessible("MSHPT04");
  }
  //#endregion
  //#region targetWebsiteDetails Attribute
  static TargetWebSiteDetail_IsAccessible() {
    return this.isAccessible("MTW00");
  }
  static targetWebsiteDetailsCreate_isAccessible() {
    return this.isAccessible("MTW01");
  }
  static targetWebsiteDetailsEdit_isAccessible() {
    return this.isAccessible("MTW02");
  }
  static targetWebsiteDetailsView_isAccessible() {
    return this.isAccessible("MTW03");
  }
  static targetWebsiteDetailsDelete_isAccessible() {
    return this.isAccessible("MTW04");
  }
  //#endRegion
  //#region Service Details
  static serviceDetails_IsAccessible() {
    return this.isAccessible("MSER00");
  }
  static serviceDetailsCreate_isAccessible() {
    return this.isAccessible("MSER01");
  }
  static serviceDetailsEdit_isAccessible() {
    return this.isAccessible("MSER02");
  }
  static serviceDetailsView_isAccessible() {
    return this.isAccessible("MSER03");
  }
  static serviceDetailsDelete_isAccessible() {
    return this.isAccessible("MSER04");
  }
  //#endRegion
  //#endregion
  //#region Customer
  //#region CustomerDivision Attribute
  static CustomerDivisionMaintenance_IsAccessible() {
    return this.isAccessible("M6080");
  }
  static CustomerDivisionMaintenanceCreate_IsAccessible() {
    return this.isAccessible("M6081");
  }
  static CustomerDivisionMaintenanceEdit_IsAccessible() {
    return this.isAccessible("M6082");
  }
  static CustomerDivisionMaintenanceView_IsAccessible() {
    return this.isAccessible("M6083");
  }
  static CustomerDivisionMaintenanceDelete_IsAccessible() {
    return this.isAccessible("M6084");
  }
  //#endregion
  //#region City Attribute
  static CityMaintenance_IsAccessible() {
    return this.isAccessible("M1130");
  }
  static CityMaintenanceCreate_IsAccessible() {
    return this.isAccessible("M1131");
  }
  static CityMaintenanceEdit_IsAccessible() {
    return this.isAccessible("M1132");
  }
  static CityMaintenanceView_IsAccessible() {
    return this.isAccessible("M1133");
  }
  static CityMaintenanceDelete_IsAccessible() {
    return this.isAccessible("M1134");
  }
  //#endregion
  //#region LogisticMethod Attribute
  static LogisticMethodMaintenance_IsAccessible() {
    return this.isAccessible("MLOG00");
  }
  static LogisticMethodMaintenanceCreate_IsAccessible() {
    return this.isAccessible("MLOG01");
  }
  static LogisticMethodMaintenanceEdit_IsAccessible() {
    return this.isAccessible("MLOG02");
  }
  static LogisticMethodMaintenanceView_IsAccessible() {
    return this.isAccessible("MLOG03");
  }
  static LogisticMethodMaintenanceDelete_IsAccessible() {
    return this.isAccessible("MLOG04");
  }
  //#endregion
  //#region CustomerSpecialType Attribute
  static CustomerSpecialTypeMaintenance_IsAccessible() {
    return this.isAccessible("M6625");
  }
  static CustomerSpecialTypeMaintenanceCreate_IsAccessible() {
    return this.isAccessible("M6626");
  }
  static CustomerSpecialTypeMaintenanceEdit_IsAccessible() {
    return this.isAccessible("M6627");
  }
  static CustomerSpecialTypeMaintenanceView_IsAccessible() {
    return this.isAccessible("M6628");
  }
  static CustomerSpecialTypeMaintenanceDelete_IsAccessible() {
    return this.isAccessible("M6629");
  }
  //#endregion
  //#region CustomerType Attribute
  static CustomerTypeMaintenance_IsAccessible() {
    return this.isAccessible("M6130");
  }
  static CustomerTypeMaintenanceCreate_IsAccessible() {
    return this.isAccessible("M6131");
  }
  static CustomerTypeMaintenanceEdit_IsAccessible() {
    return this.isAccessible("M6132");
  }
  static CustomerTypeMaintenanceView_IsAccessible() {
    return this.isAccessible("M6133");
  }
  static CustomerTypeMaintenanceDelete_IsAccessible() {
    return this.isAccessible("M6134");
  }
  //#endregion
  //#region ShipVia Attribute
  static ShipViaMaintenance_IsAccessible() {
    return this.isAccessible("M1160");
  }
  static ShipViaMaintenanceCreate_IsAccessible() {
    return this.isAccessible("M1161");
  }
  static ShipViaMaintenanceEdit_IsAccessible() {
    return this.isAccessible("M1162");
  }
  static ShipViaMaintenanceView_IsAccessible() {
    return this.isAccessible("M1163");
  }
  static ShipViaMaintenanceDelete_IsAccessible() {
    return this.isAccessible("M1164");
  }
  //#endregion
  //#region FreightMethod Attribute
  static FreightMethodMaintenance_IsAccessible() {
    return this.isAccessible("M6070");
  }
  static FreightMethodMaintenanceCreate_IsAccessible() {
    return this.isAccessible("M6071");
  }
  static FreightMethodMaintenanceEdit_IsAccessible() {
    return this.isAccessible("M6072");
  }
  static FreightMethodMaintenanceView_IsAccessible() {
    return this.isAccessible("M6073");
  }
  static FreightMethodMaintenanceDelete_IsAccessible() {
    return this.isAccessible("M6074");
  }
  //#endregion
  //#region CustomerSalesZone Attribute
  static CustomerSalesZoneMaintenance_IsAccessible() {
    return this.isAccessible("M1200");
  }
  static CustomerSalesZoneMaintenanceCreate_IsAccessible() {
    return this.isAccessible("M1201");
  }
  static CustomerSalesZoneMaintenanceEdit_IsAccessible() {
    return this.isAccessible("M1202");
  }
  static CustomerSalesZoneMaintenanceView_IsAccessible() {
    return this.isAccessible("M1203");
  }
  static CustomerSalesZoneMaintenanceDelete_IsAccessible() {
    return this.isAccessible("M1204");
  }
  //#endregion
  //#region BoxType Attribute
  static BoxTypeMaintenance_IsAccessible() {
    return this.isAccessible("M6250");
  }
  static BoxTypeMaintenanceCreate_IsAccessible() {
    return this.isAccessible("M6251");
  }
  static BoxTypeMaintenanceEdit_IsAccessible() {
    return this.isAccessible("M6252");
  }
  static BoxTypeMaintenanceView_IsAccessible() {
    return this.isAccessible("M6253");
  }
  static BoxTypeMaintenanceDelete_IsAccessible() {
    return this.isAccessible("M6254");
  }
  //#endregion
  //#region PaymentTerm Attribute
  static PaymentTermMaintenance_IsAccessible() {
    return this.isAccessible("M1030");
  }
  static PaymentTermMaintenanceCreate_IsAccessible() {
    return this.isAccessible("M1031");
  }
  static PaymentTermMaintenanceEdit_IsAccessible() {
    return this.isAccessible("M1032");
  }
  static PaymentTermMaintenanceView_IsAccessible() {
    return this.isAccessible("M1033");
  }
  static PaymentTermMaintenanceDelete_IsAccessible() {
    return this.isAccessible("M1034");
  }
  //#endregion
  //#region State Attribute
  static StateMaintenance_IsAccessible() {
    return this.isAccessible("M1120");
  }
  static StateMaintenanceCreate_IsAccessible() {
    return this.isAccessible("M1121");
  }
  static StateMaintenanceEdit_IsAccessible() {
    return this.isAccessible("M1122");
  }
  static StateMaintenanceView_IsAccessible() {
    return this.isAccessible("M1123");
  }
  static StateMaintenanceDelete_IsAccessible() {
    return this.isAccessible("M1124");
  }
  //#endregion
  //#region InvoiceTemplate Attribute
  static InvoiceTemplateMaintenance_IsAccessible() {
    return this.isAccessible("M1070");
  }
  static InvoiceTemplateMaintenanceCreate_IsAccessible() {
    return this.isAccessible("M1071");
  }
  static InvoiceTemplateMaintenanceEdit_IsAccessible() {
    return this.isAccessible("M1072");
  }
  static InvoiceTemplateMaintenanceView_IsAccessible() {
    return this.isAccessible("M1073");
  }
  static InvoiceTemplateMaintenanceDelete_IsAccessible() {
    return this.isAccessible("M1074");
  }
  //#endregion
  //#region PaymentMethod Attribute
  static PaymentMethodMaintenance_IsAccessible() {
    return this.isAccessible("M1150");
  }
  static PaymentMethodMaintenanceCreate_IsAccessible() {
    return this.isAccessible("M1151");
  }
  static PaymentMethodMaintenanceEdit_IsAccessible() {
    return this.isAccessible("M1152");
  }
  static PaymentMethodMaintenanceView_IsAccessible() {
    return this.isAccessible("M1153");
  }
  static PaymentMethodMaintenanceDelete_IsAccessible() {
    return this.isAccessible("M1154");
  }
  //#endregion
  //#region CustomerDelivery Attribute
  static CustomerDeliveryMaintenance_IsAccessible() {
    return this.isAccessible("MCSDL00");
  }
  static CustomerDeliveryMaintenanceCreate_IsAccessible() {
    return this.isAccessible("MCSDL01");
  }
  static CustomerDeliveryMaintenanceEdit_IsAccessible() {
    return this.isAccessible("MCSDL02");
  }
  static CustomerDeliveryMaintenanceView_IsAccessible() {
    return this.isAccessible("MCSDL03");
  }
  static CustomerDeliveryMaintenanceDelete_IsAccessible() {
    return this.isAccessible("MCSDL04");
  }
  //#endregion
  //#region InvoiceCancelReason Attribute
  static InvoiceCancelReasonMaintenance_IsAccessible() {
    return this.isAccessible("M6090");
  }
  static InvoiceCancelReasonMaintenanceCreate_IsAccessible() {
    return this.isAccessible("M6091");
  }
  static InvoiceCancelReasonMaintenanceEdit_IsAccessible() {
    return this.isAccessible("M6092");
  }
  static InvoiceCancelReasonMaintenanceView_IsAccessible() {
    return this.isAccessible("M6093");
  }
  static InvoiceCancelReasonMaintenanceDelete_IsAccessible() {
    return this.isAccessible("M6094");
  }
  //#endregion
  //#region InvoiceUnApprovalReason Attribute
  static InvoiceUnapprovalReasonMaintenance_IsAccessible() {
    return this.isAccessible("M6100");
  }
  static InvoiceUnapprovalReasonMaintenanceCreate_IsAccessible() {
    return this.isAccessible("M6101");
  }
  static InvoiceUnapprovalReasonMaintenanceEdit_IsAccessible() {
    return this.isAccessible("M6102");
  }
  static InvoiceUnapprovalReasonMaintenanceView_IsAccessible() {
    return this.isAccessible("M6103");
  }
  static InvoiceUnapprovalReasonMaintenanceDelete_IsAccessible() {
    return this.isAccessible("M6104");
  }
  //#endregion
  //#region InvoiceNonMerchandiseReason Attribute
  static InvoiceNonMerchandiseReasonMaintenance_IsAccessible() {
    return this.isAccessible("M6110");
  }
  static InvoiceNonMerchandiseReasonMaintenanceCreate_IsAccessible() {
    return this.isAccessible("M6111");
  }
  static InvoiceNonMerchandiseReasonMaintenanceEdit_IsAccessible() {
    return this.isAccessible("M6112");
  }
  static InvoiceNonMerchandiseReasonMaintenanceView_IsAccessible() {
    return this.isAccessible("M6113");
  }
  static InvoiceNonMerchandiseReasonMaintenanceDelete_IsAccessible() {
    return this.isAccessible("M6114");
  }
  //#endregion
  static SalesCommissionAdjustmentReasonMaintenance_IsAccessible() {
    return this.isAccessible("MSCMR00");
  }
  static SalesCommissionAdjustmentReasonMaintenanceCreate_IsAccessible() {
    return this.isAccessible("MSCMR01");
  }
  static SalesCommissionAdjustmentReasonMaintenanceEdit_IsAccessible() {
    return this.isAccessible("MSCMR02");
  }
  static SalesCommissionAdjustmentReasonMaintenanceView_IsAccessible() {
    return this.isAccessible("MSCMR03");
  }
  static SalesCommissionAdjustmentReasonMaintenanceDelete_IsAccessible() {
    return this.isAccessible("MSCMR04");
  }
  //#endregion
  //endRegion
  //#region vendor
  //#region VendorType Attribute
  static VendorTypeMaintenance_IsAccessible() {
    return this.isAccessible("MVDTY00");
  }
  static VendorTypeMaintenanceCreate_IsAccessible() {
    return this.isAccessible("MVDTY01");
  }
  static VendorTypeMaintenanceEdit_IsAccessible() {
    return this.isAccessible("MVDTY02");
  }
  static VendorTypeMaintenanceView_IsAccessible() {
    return this.isAccessible("MVDTY03");
  }
  static VendorTypeMaintenanceDelete_IsAccessible() {
    return this.isAccessible("MVDTY04");
  }
  //#endregion
  //#region FOB City
  static FobCityMaintenance_IsAccessible() {
    return this.isAccessible("M1170");
  }
  static FobCityCreate_IsAccessible() {
    return this.isAccessible("M1171");
  }
  static FobCityUpdate_IsAccessible() {
    return this.isAccessible("M1172");
  }
  static FobCityView_IsAccessible() {
    return this.isAccessible("M1173");
  }
  static FobCityDelete_IsAccessible() {
    return this.isAccessible("M1174");
  }
  // #endregion
  //#region IncoTerm Attribute
  static IncoTermMaintenance_IsAccessible() {
    return this.isAccessible("M1090");
  }
  static IncoTermMaintenanceCreate_IsAccessible() {
    return this.isAccessible("M1091");
  }
  static IncoTermMaintenanceEdit_IsAccessible() {
    return this.isAccessible("M1092");
  }
  static IncoTermMaintenanceView_IsAccessible() {
    return this.isAccessible("M1093");
  }
  static IncoTermMaintenanceDelete_IsAccessible() {
    return this.isAccessible("M1094");
  }
  //#endregion
  //#region VendorShipVia Attribute
  static VendorShipViaMaintenance_IsAccessible() {
    return this.isAccessible("M1260");
  }
  static VendorShipViaMaintenanceCreate_IsAccessible() {
    return this.isAccessible("M1261");
  }
  static VendorShipViaMaintenanceEdit_IsAccessible() {
    return this.isAccessible("M1262");
  }
  static VendorShipViaMaintenanceView_IsAccessible() {
    return this.isAccessible("M1263");
  }
  static VendorShipViaMaintenanceDelete_IsAccessible() {
    return this.isAccessible("M1264");
  }
  //#endregion
  //#region VendorTerm Attribute
  static VendorTermMaintenance_IsAccessible() {
    return this.isAccessible("M1250");
  }
  static VendorTermMaintenanceCreate_IsAccessible() {
    return this.isAccessible("M1251");
  }
  static VendorTermMaintenanceEdit_IsAccessible() {
    return this.isAccessible("M1252");
  }
  static VendorTermMaintenanceView_IsAccessible() {
    return this.isAccessible("M1253");
  }
  static VendorTermMaintenanceDelete_IsAccessible() {
    return this.isAccessible("M1254");
  }
  //#endregion
  //#region ShipmentTerm Attribute
  static ShipmentTermMaintenance_IsAccessible() {
    return this.isAccessible("M1060");
  }
  static ShipmentTermMaintenanceCreate_IsAccessible() {
    return this.isAccessible("M1061");
  }
  static ShipmentTermMaintenanceEdit_IsAccessible() {
    return this.isAccessible("M1062");
  }
  static ShipmentTermMaintenanceView_IsAccessible() {
    return this.isAccessible("M1063");
  }
  static ShipmentTermMaintenanceDelete_IsAccessible() {
    return this.isAccessible("M1064");
  }
  //#endregion
  //#region VendorCategory Attribute
  static VendorCategoryMaintenance_IsAccessible() {
    return this.isAccessible("M1040");
  }
  static VendorCategoryMaintenanceCreate_IsAccessible() {
    return this.isAccessible("M1041");
  }
  static VendorCategoryMaintenanceEdit_IsAccessible() {
    return this.isAccessible("M1042");
  }
  static VendorCategoryMaintenanceView_IsAccessible() {
    return this.isAccessible("M1043");
  }
  static VendorCategoryMaintenanceDelete_IsAccessible() {
    return this.isAccessible("M1044");
  }
  //#endregion
  //#region PurchaseOrderCancelReason Attribute
  static PurchaseOrderCancelReasonMaintenance_IsAccessible() {
    return this.isAccessible("M6260");
  }
  static PurchaseOrderCancelReasonMaintenanceCreate_IsAccessible() {
    return this.isAccessible("M6261");
  }
  static PurchaseOrderCancelReasonMaintenanceEdit_IsAccessible() {
    return this.isAccessible("M6262");
  }
  static PurchaseOrderCancelReasonMaintenanceView_IsAccessible() {
    return this.isAccessible("M6263");
  }
  static PurchaseOrderCancelReasonMaintenanceDelete_IsAccessible() {
    return this.isAccessible("M6264");
  }
  //#endregion
  //#region PurchaseOrderUnApprovalReason Attribute
  static PurchaseOrderUnApprovalReasonMaintenance_IsAccessible() {
    return this.isAccessible("M6140");
  }
  static PurchaseOrderUnApprovalReasonMaintenanceCreate_IsAccessible() {
    return this.isAccessible("M6141");
  }
  static PurchaseOrderUnApprovalReasonMaintenanceEdit_IsAccessible() {
    return this.isAccessible("M6142");
  }
  static PurchaseOrderUnApprovalReasonMaintenanceView_IsAccessible() {
    return this.isAccessible("M6143");
  }
  static PurchaseOrderUnApprovalReasonMaintenanceDelete_IsAccessible() {
    return this.isAccessible("M6144");
  }
  //#endregion
  //#region MiscellaneousChargeReason Attribute
  static MiscellaneousChargeReasonMaintenance_IsAccessible() {
    return this.isAccessible("M6150");
  }
  static MiscellaneousChargeReasonMaintenanceCreate_IsAccessible() {
    return this.isAccessible("M6151");
  }
  static MiscellaneousChargeReasonMaintenanceEdit_IsAccessible() {
    return this.isAccessible("M6152");
  }
  static MiscellaneousChargeReasonMaintenanceView_IsAccessible() {
    return this.isAccessible("M6153");
  }
  static MiscellaneousChargeReasonMaintenanceDelete_IsAccessible() {
    return this.isAccessible("M6154");
  }
  //#endregion
  //#region PurchaseOrderModel Attribute
  static PurchaseOrderModelMaintenance_IsAccessible() {
    return this.isAccessible("MPOMDL00");
  }
  static PurchaseOrderModelMaintenanceCreate_IsAccessible() {
    return this.isAccessible("MPOMDL01");
  }
  static PurchaseOrderModelMaintenanceEdit_IsAccessible() {
    return this.isAccessible("MPOMDL02");
  }
  static PurchaseOrderModelMaintenanceView_IsAccessible() {
    return this.isAccessible("MPOMDL03");
  }
  static PurchaseOrderModelMaintenanceDelete_IsAccessible() {
    return this.isAccessible("MPOMDL04");
  }
  //#endregion
  //#endRegion
  //#region Production
  //#region StageCollection
  static StageCollectionMaintenance_IsAccessible() {
    return this.isAccessible("MP6260");
  }
  static StageCollectionMaintenanceCreate_IsAccessible() {
    return this.isAccessible("MP6261");
  }
  static StageCollectionMaintenanceEdit_IsAccessible() {
    return this.isAccessible("MP6262");
  }
  static StageCollectionMaintenanceView_IsAccessible() {
    return this.isAccessible("MP6263");
  }
  static StageCollectionMaintenanceDelete_IsAccessible() {
    return this.isAccessible("MP6264");
  }
  //#endregion
  //#region PreProductionChangeReason Attribute
  static PreProductionChangeReasonMaintenance_IsAccessible() {
    return this.isAccessible("MP6250");
  }
  static PreProductionChangeReasonCreate_IsAccessible() {
    return this.isAccessible("MP6251");
  }
  static PreProductionChangeReasonEdit_IsAccessible() {
    return this.isAccessible("MP6252");
  }
  static PreProductionChangeReasonView_IsAccessible() {
    return this.isAccessible("MP6253");
  }
  static PreProductionChangeReasonDelete_IsAccessible() {
    return this.isAccessible("MP6254");
  }
  //#endregion
  //#endRegion
  //#region Accounts
  //#region GeneralLedgerAccountType Attribute
  static GeneralLedgerAccountTypeMaintenance_IsAccessible() {
    return this.isAccessible("M6160");
  }
  static GeneralLedgerAccountTypeMaintenanceCreate_IsAccessible() {
    return this.isAccessible("M6161");
  }
  static GeneralLedgerAccountTypeMaintenanceEdit_IsAccessible() {
    return this.isAccessible("M6162");
  }
  static GeneralLedgerAccountTypeMaintenanceView_IsAccessible() {
    return this.isAccessible("M6163");
  }
  static GeneralLedgerAccountTypeMaintenanceDelete_IsAccessible() {
    return this.isAccessible("M6164");
  }
  //#endregion
  //#region GeneralLedgerAccount Attribute
  static GeneralLedgerAccountMaintenance_IsAccessible() {
    return this.isAccessible("M6170");
  }
  static GeneralLedgerAccountMaintenanceCreate_IsAccessible() {
    return this.isAccessible("M6171");
  }
  static GeneralLedgerAccountMaintenanceEdit_IsAccessible() {
    return this.isAccessible("M6172");
  }
  static GeneralLedgerAccountMaintenanceView_IsAccessible() {
    return this.isAccessible("M6173");
  }
  static GeneralLedgerAccountMaintenanceDelete_IsAccessible() {
    return this.isAccessible("M6174");
  }
  //#endregion
  //#region AR Discount Reason Attribute
  static ArDiscountReasonMaintenance_IsAccessible() {
    return this.isAccessible("M6180");
  }
  static ArDiscountReasonMaintenanceCreate_IsAccessible() {
    return this.isAccessible("M6181");
  }
  static ArDiscountReasonMaintenanceEdit_IsAccessible() {
    return this.isAccessible("M6182");
  }
  static ArDiscountReasonMaintenanceView_IsAccessible() {
    return this.isAccessible("M6183");
  }
  static ArDiscountReasonMaintenanceDelete_IsAccessible() {
    return this.isAccessible("M6184");
  }
  //#endregion
  //#region CustomerTenderReason Attribute
  static CustomerTenderReasonMaintenance_IsAccessible() {
    return this.isAccessible("M6190");
  }
  static CustomerTenderReasonMaintenanceCreate_IsAccessible() {
    return this.isAccessible("M6191");
  }
  static CustomerTenderReasonMaintenanceEdit_IsAccessible() {
    return this.isAccessible("M6192");
  }
  static CustomerTenderReasonMaintenanceView_IsAccessible() {
    return this.isAccessible("M6193");
  }
  static CustomerTenderReasonMaintenanceDelete_IsAccessible() {
    return this.isAccessible("M6194");
  }
  //#endregion
  //#region CustomerTenderCancelReason Attribute
  static CustomerTenderCancelReasonMaintenance_IsAccessible() {
    return this.isAccessible("M6200");
  }
  static CustomerTenderCancelReasonMaintenanceCreate_IsAccessible() {
    return this.isAccessible("M6201");
  }
  static CustomerTenderCancelReasonMaintenanceEdit_IsAccessible() {
    return this.isAccessible("M6202");
  }
  static CustomerTenderCancelReasonMaintenanceView_IsAccessible() {
    return this.isAccessible("M6203");
  }
  static CustomerTenderCancelReasonMaintenanceDelete_IsAccessible() {
    return this.isAccessible("M6204");
  }
  //#endregion
  //#region CustomerTenderUnApprovalReason Attribute
  static CustomerTenderUnapporveReasonMaintenance_IsAccessible() {
    return this.isAccessible("M6210");
  }
  static CustomerTenderUnapporveReasonMaintenanceCreate_IsAccessible() {
    return this.isAccessible("M6211");
  }
  static CustomerTenderUnapporveReasonMaintenanceEdit_IsAccessible() {
    return this.isAccessible("M6212");
  }
  static CustomerTenderUnapporveReasonMaintenanceView_IsAccessible() {
    return this.isAccessible("M6213");
  }
  static CustomerTenderUnapporveReasonMaintenanceDelete_IsAccessible() {
    return this.isAccessible("M6214");
  }
  //#endregion
  //#region AccountReceivableReversalReason Attribute
  static ArReversalReasonMaintenance_IsAccessible() {
    return this.isAccessible("M6220");
  }
  static ArReversalReasonMaintenanceCreate_IsAccessible() {
    return this.isAccessible("M6221");
  }
  static ArReversalReasonMaintenanceEdit_IsAccessible() {
    return this.isAccessible("M6222");
  }
  static ArReversalReasonMaintenanceView_IsAccessible() {
    return this.isAccessible("M6223");
  }
  static ArReversalReasonMaintenanceDelete_IsAccessible() {
    return this.isAccessible("M6224");
  }
  static ExpenseTypeMaintenance_IsAccessible() {
    return this.isAccessible("M6060");
  }
  static ExpenseTypeMaintenanceCreate_IsAccessible() {
    return this.isAccessible("M6061");
  }
  static ExpenseTypeMaintenanceEdit_IsAccessible() {
    return this.isAccessible("M6062");
  }
  static ExpenseTypeMaintenanceView_IsAccessible() {
    return this.isAccessible("M6063");
  }
  static ExpenseTypeMaintenanceDelete_IsAccessible() {
    return this.isAccessible("M6064");
  }
  //#endregion
  //#region ExpenseSubType Attribute
  static ExpenseSubTypeMaintenance_IsAccessible() {
    return this.isAccessible("MEXSTY00");
  }
  static ExpenseSubTypeMaintenanceCreate_IsAccessible() {
    return this.isAccessible("MEXSTY01");
  }
  static ExpenseSubTypeMaintenanceEdit_IsAccessible() {
    return this.isAccessible("MEXSTY02");
  }
  static ExpenseSubTypeMaintenanceView_IsAccessible() {
    return this.isAccessible("MEXSTY03");
  }
  static ExpenseSubTypeMaintenanceDelete_IsAccessible() {
    return this.isAccessible("MEXSTY04");
  }
  //#endregion
  //#region BankAdjustmentReason Attribute
  static BankAdjustmentReasonMaintenance_IsAccessible() {
    return this.isAccessible("MBADJR00");
  }
  static BankAdjustmentReasonMaintenanceCreate_IsAccessible() {
    return this.isAccessible("MBADJR01");
  }
  static BankAdjustmentReasonMaintenanceEdit_IsAccessible() {
    return this.isAccessible("MBADJR02");
  }
  static BankAdjustmentReasonMaintenanceView_IsAccessible() {
    return this.isAccessible("MBADJR03");
  }
  static BankAdjustmentReasonMaintenanceDelete_IsAccessible() {
    return this.isAccessible("MBADJR04");
  }
  //#endregion
  //#region DepositCancelReason Attribute
  static DepositCancelReasonMaintenance_IsAccessible() {
    return this.isAccessible("MDCLR00");
  }
  static DepositCancelReasonMaintenanceCreate_IsAccessible() {
    return this.isAccessible("MDCLR01");
  }
  static DepositCancelReasonMaintenanceEdit_IsAccessible() {
    return this.isAccessible("MDCLR02");
  }
  static DepositCancelReasonMaintenanceView_IsAccessible() {
    return this.isAccessible("MDCLR03");
  }
  static DepositCancelReasonMaintenanceDelete_IsAccessible() {
    return this.isAccessible("MDCLR04");
  }
  //#endregion
  //#region DepositReversalReason Attribute
  static DepositReversalReasonMaintenance_IsAccessible() {
    return this.isAccessible("MDRVR00");
  }
  static DepositReversalReasonMaintenanceCreate_IsAccessible() {
    return this.isAccessible("MDRVR01");
  }
  static DepositReversalReasonMaintenanceEdit_IsAccessible() {
    return this.isAccessible("MDRVR02");
  }
  static DepositReversalReasonMaintenanceView_IsAccessible() {
    return this.isAccessible("MDRVR03");
  }
  static DepositReversalReasonMaintenanceDelete_IsAccessible() {
    return this.isAccessible("MDRVR04");
  }
  //#endregion
  //#region BankAccount Attribute
  static BankAccountMaintenance_IsAccessible() {
    return this.isAccessible("MA6240");
  }
  static BankAccountMaintenanceCreate_IsAccessible() {
    return this.isAccessible("MA6241");
  }
  static BankAccountMaintenanceEdit_IsAccessible() {
    return this.isAccessible("MA6242");
  }
  static BankAccountMaintenanceView_IsAccessible() {
    return this.isAccessible("MA6243");
  }
  static BankAccountMaintenanceDelete_IsAccessible() {
    return this.isAccessible("MA6244");
  }
  //#endregion
  //#endRegion
  //#region fabric
  //#region FabricDetail Attribute
  static FabricDetailMaintenance_IsAccessible() {
    return this.isAccessible("MFDA00");
  }
  static FabricDetailMaintenanceCreate_IsAccessible() {
    return this.isAccessible("MFDA01");
  }
  static FabricDetailMaintenanceEdit_IsAccessible() {
    return this.isAccessible("MFDA02");
  }
  static FabricDetailMaintenanceView_IsAccessible() {
    return this.isAccessible("MFDA03");
  }
  static FabricDetailMaintenanceDelete_IsAccessible() {
    return this.isAccessible("MFDA04");
  }
  static FabricDetailMaintenancePDFReport_IsAccessible() {
    return this.isAccessible("MFDA05");
  }
  static FabricDetailMaintenanceExcelReport_IsAccessible() {
    return this.isAccessible("MFDA06");
  }
  static FabricDetailDesignDirectionMaintenance_IsAccessible() {
    return this.isAccessible("MFDA07");
  }
  static FabricDetailBackedMaintenance_IsAccessible() {
    return this.isAccessible("MFDA08");
  }
  static FabricDetailBakedTypesMaintenance_IsAccessible() {
    return this.isAccessible("MFDA09");
  }
  static FabricDetailBoundBackTypesMaintenance_IsAccessible() {
    return this.isAccessible("MFDA10");
  }
  static FabricDetailcardedOrCombedMaintenance_IsAccessible() {
    return this.isAccessible("MFDA11");
  }
  static FabricDetailFilingYarnsMaintenance_IsAccessible() {
    return this.isAccessible("MFDA12");
  }
  static FabricDetailFillingYarnTexturedMaintenance_IsAccessible() {
    return this.isAccessible("MFDA13");
  }
  static FabricDetailFillingYarnStwistedMaintenance_IsAccessible() {
    return this.isAccessible("MFDA14");
  }
  static FabricDetailNappedMaintenance_IsAccessible() {
    return this.isAccessible("MFDA15");
  }
  static FabricDetailPrintedMaintenance_IsAccessible() {
    return this.isAccessible("MFDA16");
  }
  static FabricDetailWarpYarnsMaintenance_IsAccessible() {
    return this.isAccessible("MFDA17");
  }
  static FabricDetailWarpYarnsTexturedMaintenance_IsAccessible() {
    return this.isAccessible("MFDA18");
  }
  static FabricDetailWarpYarnsTwistedMaintenance_IsAccessible() {
    return this.isAccessible("MFDA19");
  }
  static FabricDetailWashedMaintenance_IsAccessible() {
    return this.isAccessible("MFDA20");
  }
  //#endregion
  //#endRegion
  //#endregion
  //#region Master
  //#region Item
  static ItemMaintenance_IsAccessible() {
    return this.isAccessible("MIM00");
  }
  static ItemMaintenanceCreate_IsAccessible() {
    return this.isAccessible("MIM01");
  }
  static ItemMaintenanceEdit_IsAccessible() {
    return this.isAccessible("MIM02");
  }
  static ItemMaintenanceView_IsAccessible() {
    return this.isAccessible("MIM03");
  }
  static ItemMaintenanceRemove_IsAccessible() {
    return this.isAccessible("MIM04");
  }
  static ItemMaintenancePriceChange_IsAccessible() {
    return this.isAccessible("MIM05");
  }
  static ItemMaintenanceCostChange_IsAccessible() {
    return this.isAccessible("MIM06");
  }
  static ItemMaintenanceCostView_IsAccessible() {
    return this.isAccessible("MIM07");
  }
  static ItemMaintenanceColorRemove_IsAccessible() {
    return this.isAccessible("MIM08");
  }
  //#endregion
  //#region Customer
  static CustomerMaintenance_IsAccessible() {
    return this.isAccessible("MCS00");
  }
  static CustomerMaintenanceCreate_IsAccessible() {
    return this.isAccessible("MCS01");
  }
  static CustomerMaintenanceEdit_IsAccessible() {
    return this.isAccessible("MCS02");
  }
  static CustomerMaintenanceView_IsAccessible() {
    return this.isAccessible("MCS03");
  }
  static CustomerMaintenanceDelete_IsAccessible() {
    return this.isAccessible("MCS04");
  }
  static CustomerMaintenanceHistory_IsAccessible() {
    return this.isAccessible("MCS05");
  }
  //#endregion
  //#region Vendor
  static VendorMaintenance_IsAccessible() {
    return this.isAccessible("MVN00");
  }
  static VendorMaintenanceCreate_IsAccessible() {
    return this.isAccessible("MVN01");
  }
  static VendorMaintenanceEdit_IsAccessible() {
    return this.isAccessible("MVN02");
  }
  static VendorMaintenanceView_IsAccessible() {
    return this.isAccessible("MVN03");
  }
  static VendorFactoryMaintenance_IsAccessible() {
    return this.isAccessible("MVN10");
  }
  static VendorFactoryMaintenanceCreate_IsAccessible() {
    return this.isAccessible("MVN11");
  }
  static VendorFactoryMaintenanceEdit_IsAccessible() {
    return this.isAccessible("MVN12");
  }
  static VendorFactoryMaintenanceView_IsAccessible() {
    return this.isAccessible("MVN13");
  }
  //#endregion
  //#region
  static FabricStyleCostSheetMaintenance_IsAccessible() {
    return this.isAccessible("FSCM00");
  }
  static FabricStyleCostSheetCreation_IsAccessible() {
    return this.isAccessible("FSCM01");
  }
  static FabricStyleCostSheetUpdation_IsAccessible() {
    return this.isAccessible("FSCM02");
  }
  static FabricStyleCostSheetView_IsAccessible() {
    return this.isAccessible("FSCM03");
  }
  static FabricStyleCostSheetApproval_IsAccessible() {
    return this.isAccessible("FSCM04");
  }
  //#endregion
  //#endRegion
  //#region Sales
  //#region SalesOrder
  static SalesOrderMaintenance_IsAccessible() {
    return this.isAccessible("TSL00");
  }
  static SalesOrderMaintenanceAdd_IsAccessible() {
    return this.isAccessible("TSL01");
  }
  static SalesOrderMaintenanceEdit_IsAccessible() {
    return this.isAccessible("TSL02");
  }
  static SalesOrderMaintenanceView_IsAccessible() {
    return this.isAccessible("TSL03");
  }
  static SalesOrderMaintenanceApprove_IsAccessible() {
    return this.isAccessible("TSL04");
  }
  static SalesOrderMaintenanceUnApprove_IsAccessible() {
    return this.isAccessible("TSL05");
  }
  static SalesOrderMaintenanceCancel_IsAccessible() {
    return this.isAccessible("TSL06");
  }
  static SalesOrderMaintenanceForceClose_IsAccessible() {
    return this.isAccessible("TSL07");
  }
  static SalesOrderMaintenancePDF_Report_IsAccessible() {
    return this.isAccessible("TSL08");
  }
  static SalesOrderMaintenanceExcel_Report_IsAccessible() {
    return this.isAccessible("TSL09");
  }
  static SalesOrderMaintenanceSendMail_IsAccessible() {
    return this.isAccessible("TSL10");
  }
  static SalesOrderMaintenanceHold_IsAccessible() {
    return this.isAccessible("TSL11");
  }
  static SalesOrderMaintenanceRelease_IsAccessible() {
    return this.isAccessible("TSL12");
  }
  static SalesOrderMaintenanceLineCancel_IsAccessible() {
    return this.isAccessible("TSL13");
  }
  static SalesOrderMaintenanceProformaInvoice_IsAccessible() {
    return this.isAccessible("TSL14");
  }
  static SalesOrderMaintenanceModify_IsAccessible() {
    return this.isAccessible("TSL15");
  }
  static SalesOrderMaintenanceValidateCCPayment_IsAccessible() {
    return this.isAccessible("TSL16");
  }
  static SalesOrderPrintReport_IsAccessible() {
    return this.isAccessible("TSL17");
  }
  static SalesOrderPickTicketReport_IsAccessible() {
    return this.isAccessible("TSL18");
  }
  static SalesOrderMaintenanceSpecialApprove_IsAccessible() {
    return this.isAccessible("TSL19");
  }
  //#endregion
  //#region Mass Sales Order PickTicket Generation
  static MassSalesOrderPickTicketGenerationMaintenance_IsAccessible() {
    return this.isAccessible("IMSOP00");
  }
  static MassSalesOrderPickTicketGenerationPDFReport_IsAccessible() {
    return this.isAccessible("IMSOP01");
  }
  static MassSalesOrderPickTicketGenerationExcelReport_IsAccessible() {
    return this.isAccessible("IMSOP02");
  }
  //#endregion
  //#region Pickticket
  static PickticketMaintenance_IsAccessible() {
    return this.isAccessible("PT00");
  }
  static PickticketMaintenanceCreate_IsAccessible() {
    return this.isAccessible("PT01");
  }
  static PickticketMaintenanceEdit_IsAccessible() {
    return this.isAccessible("PT02");
  }
  static PickticketMaintenanceView_IsAccessible() {
    return this.isAccessible("PT03");
  }
  static PickticketMaintenanceApprove_IsAccessible() {
    return this.isAccessible("PT04");
  }
  static PickticketMaintenanceCancel_IsAccessible() {
    return this.isAccessible("PT05");
  }
  static PickticketMaintenanceReport_IsAccessible() {
    return this.isAccessible("PT06");
  }
  static PickticketMaintenanceMail_IsAccessible() {
    return this.isAccessible("PT07");
  }
  static PickticketMaintenanceVoidShipment_IsAccessible() {
    return this.isAccessible("PT08");
  }
  static PickticketMaintenancePDFReport_IsAccessible() {
    return this.isAccessible("PT09");
  }
  static PickticketMaintenanceModify_IsAccessible() {
    return this.isAccessible("PT10");
  }
  //# end Region
  //#region Invoice
  static InvoiceMaintenance_IsAccessible() {
    return this.isAccessible("TIN00");
  }
  static InvoiceMaintenanceAdd_IsAccessible() {
    return this.isAccessible("TIN01");
  }
  static InvoiceMaintenanceEdit_IsAccessible() {
    return this.isAccessible("TIN02");
  }
  static InvoiceMaintenanceView_IsAccessible() {
    return this.isAccessible("TIN03");
  }
  static InvoiceMaintenanceApprove_IsAccessible() {
    return this.isAccessible("TIN04");
  }
  static InvoiceMaintenanceUnApprove_IsAccessible() {
    return this.isAccessible("TIN05");
  }
  static InvoiceMaintenanceCancel_IsAccessible() {
    return this.isAccessible("TIN06");
  }
  static InvoiceMaintenancePDFReport_IsAccessible() {
    return this.isAccessible("TIN07");
  }
  static InvoiceMaintenanceExcelReport_IsAccessible() {
    return this.isAccessible("TIN08");
  }
  static InvoiceMaintenanceSendMailReport_IsAccessible() {
    return this.isAccessible("TIN09");
  }
  static InvoiceMaintenanceModify_IsAccessible() {
    return this.isAccessible("TIN10");
  }
  static InvoiceMaintenanceSalesPersonUpdate_IsAccessible() {
    return this.isAccessible("TIN11");
  }
  static InvoiceMaintenanceLineCancel_IsAccessible() {
    return this.isAccessible("TIN12");
  }
  static InvoiceMaintenancePriceChange_IsAccessible() {
    return this.isAccessible("TIN13");
  }
  static InvoiceMaintenancePrintReport_IsAccessible() {
    return this.isAccessible("TIN14");
  }
  //#endregion
  //#region Sales Commission Maintenance
  static SalesCommissionMaintenance_Accessible() {
    return this.isAccessible("SC00");
  }
  static SalesCommissionCreation_Accessible() {
    return this.isAccessible("SC01");
  }
  static SalesCommissionPay_Accessible() {
    return this.isAccessible("SC02");
  }
  static SalesCommissionAdjust_Accessible() {
    return this.isAccessible("SC03");
  }
  static SalesCommissionApproval_Accessible() {
    return this.isAccessible("SC04");
  }
  static SalesCommissionUnApproval_Accessible() {
    return this.isAccessible("SC05");
  }
  static SalesCommissionCancel_Accessible() {
    return this.isAccessible("SC06");
  }
  static SalesCommissionUpdation_Accessible() {
    return this.isAccessible("SC07");
  }
  static SalesCommissionView_Accessible() {
    return this.isAccessible("SC08");
  }
  static SalesCommissionPDF_Report_Accessible() {
    return this.isAccessible("SC09");
  }
  static SalesCommissionExcel_Report_Accessible() {
    return this.isAccessible("SC10");
  }
  static SalesCommissionSend_Mail_Accessible() {
    return this.isAccessible("SC11");
  }
  //#end region
  //#region Mass Maintenance
  //#region Approve SalesOrder
  static MassApproveSalesOrders_IsAccessible() {
    return this.isAccessible("MS00");
  }
  //#endRegion
  //#region Cancel BackOrder
  static MassCancelBackOrders_IsAccessible() {
    return this.isAccessible("MS01");
  }
  //#endRegion
  //#region Mass Cancel SalesOrder
  static MassCancelSalesOrder_IsAccessible() {
    return this.isAccessible("MCSO00");
  }
  static MassCancelSalesOrderCreate_IsAccessible() {
    return this.isAccessible("MCSO01");
  }
  static MassCancelSalesOrderEdit_IsAccessible() {
    return this.isAccessible("MCSO02");
  }
  static MassCancelSalesOrderView_IsAccessible() {
    return this.isAccessible("MCSO03");
  }
  static MassCancelSalesOrderDelete_IsAccessible() {
    return this.isAccessible("MCSO04");
  }
  //#endRegion
  //#region Generate PickTicket
  static MassGenaratePickTickets_IsAccessible() {
    return this.isAccessible("MS02");
  }
  //#endRegion
  //#region Generate Invoice
  static MassGenarateInvoices_IsAccessible() {
    return this.isAccessible("MS03");
  }
  //#endRegion
  //#region Approve Invoice
  static MassApproveInvoices_IsAccessible() {
    return this.isAccessible("MS04");
  }
  //#endRegion
  //#region Bulk PickTicket
  static BulkPickTicketInquiry_IsAccessible() {
    return this.isAccessible("IBP000");
  }
  static BulkPickTicketInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IBP001");
  }
  static BulkPickTicketInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IBP002");
  }
  static BulkPickTicketInquiryMailReport_IsAccessible() {
    return this.isAccessible("IBP003");
  }
  //#endRegion
  //#region Mass SalesOrder Print
  static MassSalesOrderInquiry_IsAccessible() {
    return this.isAccessible("MSOI00");
  }
  static MassSalesOrderInquiryPDFReport_IsAccessible() {
    return this.isAccessible("MSOI01");
  }
  static MassSalesOrderInquiryExcelReport_IsAccessible() {
    return this.isAccessible("MSOI02");
  }
  //#endRegion
  //#region PickTicket Roll Utility
  static PrintPickTickLabelMaintenance_IsAccessible() {
    return this.isAccessible("PTRU00");
  }
  static PrintPickTickLabelCreate_IsAccessible() {
    return this.isAccessible("PTRU01");
  }
  static PrintPickTickLabelEdit_IsAccessible() {
    return this.isAccessible("PTRU02");
  }
  static PrintPickTickLabelView_IsAccessible() {
    return this.isAccessible("PTRU03");
  }
  static PrintPickTickLabelDelete_IsAccessible() {
    return this.isAccessible("PTRU04");
  }
  //#endRegion
  //#region Commercial Invoice For Multiple Invoice
  static CommercailInvoiceForMultipleInvoice_IsAccessible() {
    return this.isAccessible("CIFMI00");
  }
  static CommercailInvoiceForMultipleInvoiceCreate_IsAccessible() {
    return this.isAccessible("CIFMI01");
  }
  static CommercailInvoiceForMultipleInvoiceEdit_IsAccessible() {
    return this.isAccessible("CIFMI02");
  }
  static CommercailInvoiceForMultipleInvoiceView_IsAccessible() {
    return this.isAccessible("CIFMI03");
  }
  static CommercailInvoiceForMultipleInvoiceDelete_IsAccessible() {
    return this.isAccessible("CIFMI04");
  }
  //#endRegion
  //#region Advanced Mass SalesOrder PickTicket Generation
  static AdvancedMassSalesOrderPickTicketGenerationInquiry_IsAccessible() {
    return this.isAccessible("AMSPG0");
  }
  static AdvancedMassSalesOrderPickTicketGenerationInquiryPDFReport_IsAccessible() {
    return this.isAccessible("AMSPG1");
  }
  static AdvancedMassSalesOrderPickTicketGenerationInquiryExcelReport_IsAccessible() {
    return this.isAccessible("AMSPG2");
  }
  //#endRegion
  //#region Invoice For Multiple PickTicket
  static InvoiceForMultiplePickticket_IsAccessible() {
    return this.isAccessible("IFMPT00");
  }
  static InvoiceForMultiplePickticketCreate_IsAccessible() {
    return this.isAccessible("IFMPT01");
  }
  static InvoiceForMultiplePickticketEdit_IsAccessible() {
    return this.isAccessible("IFMPT02");
  }
  static InvoiceForMultiplePickticketView_IsAccessible() {
    return this.isAccessible("IFMPT03");
  }
  //#endRegion
  //#region Mail Invoices
  static MultiInvoiceMail_IsAccessible() {
    return this.isAccessible("MA01");
  }
  static MultiInvoiceSendMail_IsAccessible() {
    return this.isAccessible("MA02");
  }
  //#endRegion
  //#endRegion
  //#endRegion
  //#region CPM
  //#region Development CPM
  static PreProductionMaintenance_IsAccessible() {
    return this.isAccessible("PRE00");
  }
  static PreProductionCreation_IsAccessible() {
    return this.isAccessible("PRE01");
  }
  static PreProductionUpdation_IsAccessible() {
    return this.isAccessible("PRE02");
  }
  static PreProductionView_IsAccessible() {
    return this.isAccessible("PRE03");
  }
  static PreProductionApproval_IsAccessible() {
    return this.isAccessible("PRE04");
  }
  static PreProductionUnApproval_IsAccessible() {
    return this.isAccessible("PRE05");
  }
  static PreProductionCancelApproval_IsAccessible() {
    return this.isAccessible("PRE06");
  }
  static PreProductionPDFReport_IsAccessible() {
    return this.isAccessible("PRE07");
  }
  static PreProductionExcelReport_IsAccessible() {
    return this.isAccessible("PRE08");
  }
  static PreProductionSendReport_IsAccessible() {
    return this.isAccessible("PRE09");
  }
  static PreProductionModify_IsAccessible() {
    return this.isAccessible("PRE10");
  }
  static PreProductionFinish_IsAccessible() {
    return this.isAccessible("PRE11");
  }
  static PreProductionCancel_IsAccessible() {
    return this.isAccessible("PRE12");
  }
  static PreProductionSubmit_IsAccessible() {
    return this.isAccessible("PRE13");
  }
  static PreProductionReSubmit_IsAccessible() {
    return this.isAccessible("PRE14");
  }
  //#endRegion
  //#endRegion
  //#region Purchase
  // #region  Purchase Order
  static PurchaseOrderMaintenance_IsAccessible() {
    return this.isAccessible("TPO00");
  }
  static PurchaseOrderMaintenanceCreate_IsAccessible() {
    return this.isAccessible("TPO01");
  }
  static PurchaseOrderMaintenanceEdit_IsAccessible() {
    return this.isAccessible("TPO02");
  }
  static PurchaseOrderMaintenanceView_IsAccessible() {
    return this.isAccessible("TPO03");
  }
  static PurchaseOrderMaintenanceApprove_IsAccessible() {
    return this.isAccessible("TPO04");
  }
  static PurchaseOrderMaintenanceUnApprove_IsAccessible() {
    return this.isAccessible("TPO05");
  }
  static PurchaseOrderMaintenanceCancel_IsAccessible() {
    return this.isAccessible("TPO06");
  }
  static PurchaseOrderMaintenanceClose_IsAccessible() {
    return this.isAccessible("TPO07");
  }
  static PurchaseOrderMaintenancePDFReport_IsAccessible() {
    return this.isAccessible("TPO08");
  }
  static PurchaseOrderMaintenanceExcelReport_IsAccessible() {
    return this.isAccessible("TPO09");
  }
  static PurchaseOrderMaintenanceSendMailReport_IsAccessible() {
    return this.isAccessible("TPO10");
  }
  static PurchaseOrderMaintenanceModify_IsAccessible() {
    return this.isAccessible("TPO11");
  }
  static PurchaseOrderMaintenanceLineCancel_IsAccessible() {
    return this.isAccessible("TPO12");
  }
  //#endregion
  // #region Mass PurchaseOrder
  static MassPurchaseOrderMaintenance_IsAccessible() {
    return this.isAccessible("MPOI00");
  }
  static MassPurchaseOrderPDFReport_IsAccessible() {
    return this.isAccessible("MPOI01");
  }
  static MassPurchaseOrderExcelReport_IsAccessible() {
    return this.isAccessible("MPOI02");
  }
  //#endregion
  // #region Mass Cancel Purchase Orders
  static MassCancelPurchaseOrder_IsAccessible() {
    return this.isAccessible("MCPO00");
  }
  static MassCancelPurchaseOrderCreate_IsAccessible() {
    return this.isAccessible("MCPO01");
  }
  static MassCancelPurchaseOrderEdit_IsAccessible() {
    return this.isAccessible("MCPO02");
  }
  static MassCancelPurchaseOrderView_IsAccessible() {
    return this.isAccessible("MCPO03");
  }
  static MassCancelPurchaseOrderDelete_IsAccessible() {
    return this.isAccessible("MCPO04");
  }
  //#endregion
  //#region Approve Cancel Purchase Orders
  static MassCancelPurchaseOrderInquiry_IsAccessible() {
    return this.isAccessible("MCLPO00");
  }
  static MassCancelPurchaseOrderInquiryPDFReport_IsAccessible() {
    return this.isAccessible("MCLPO01");
  }
  static MassCancelPurchaseOrderInquiryExcelReport_IsAccessible() {
    return this.isAccessible("MCLPO02");
  }
  static MassCancelPurchaseOrderInquiryancel_IsAccessible() {
    return this.isAccessible("MCLPO03");
  }
  //#endregion
  // #region  Purchase Order InTransit
  static PurchaseOrderInTransitMaintenance_IsAccessible() {
    return this.isAccessible("POIT00");
  }
  static PurchaseOrderInTransitMaintenanceCreate_IsAccessible() {
    return this.isAccessible("POIT01");
  }
  static PurchaseOrderInTransitMaintenanceUpdate_IsAccessible() {
    return this.isAccessible("POIT02");
  }
  static PurchaseOrderInTransitMaintenanceView_IsAccessible() {
    return this.isAccessible("POIT03");
  }
  static PurchaseOrderInTransitMaintenanceApprove_IsAccessible() {
    return this.isAccessible("POIT04");
  }
  static PurchaseOrderInTransitMaintenanceUnApprove_IsAccessible() {
    return this.isAccessible("POIT05");
  }
  static PurchaseOrderInTransitMaintenanceCancel_IsAccessible() {
    return this.isAccessible("POIT06");
  }
  static PurchaseOrderInTransitMaintenanceClose_IsAccessible() {
    return this.isAccessible("POIT07");
  }
  static PurchaseOrderInTransitMaintenancePDFReport_IsAccessible() {
    return this.isAccessible("POIT08");
  }
  static PurchaseOrderInTransitMaintenanceExcelReport_IsAccessible() {
    return this.isAccessible("POIT09");
  }
  static PurchaseOrderInTransitMaintenanceSendReport_IsAccessible() {
    return this.isAccessible("POIT10");
  }
  static PurchaseOrderInTransitMaintenanceModify_IsAccessible() {
    return this.isAccessible("POIT11");
  }
  static PurchaseOrderInTransitMaintenanceLineCancel_IsAccessible() {
    return this.isAccessible("POIT12");
  }
  //#endregion
  //#region Purchase Order Receipt
  static PurchaseOrderReceiptMaintenance_IsAccessible() {
    return this.isAccessible("TPR00");
  }
  static PurchaseOrderReceiptMaintenanceCreate_IsAccessible() {
    return this.isAccessible("TPR01");
  }
  static PurchaseOrderReceiptMaintenanceEdit_IsAccessible() {
    return this.isAccessible("TPR02");
  }
  static PurchaseOrderReceiptMaintenanceView_IsAccessible() {
    return this.isAccessible("TPR03");
  }
  static PurchaseOrderReceiptMaintenanceApprove_IsAccessible() {
    return this.isAccessible("TPR04");
  }
  static PurchaseOrderReceiptMaintenanceUnApprove_IsAccessible() {
    return this.isAccessible("TPR05");
  }
  static PurchaseOrderReceiptMaintenanceConfirm_IsAccessible() {
    // For Future Use
    return this.isAccessible("TPR06");
  }
  static PurchaseOrderReceiptMaintenanceClose_IsAccessible() {
    return this.isAccessible("TPR07");
  }
  static PurchaseOrderReceiptMaintenanceCancel_IsAccessible() {
    return this.isAccessible("TPR08");
  }
  static PurchaseOrderReceiptMaintenancePDFReport_IsAccessible() {
    return this.isAccessible("TPR09");
  }
  static PurchaseOrderReceiptMaintenanceExcelReport_IsAccessible() {
    return this.isAccessible("TPR10");
  }
  static PurchaseOrderReceiptMaintenanceSendReport_IsAccessible() {
    return this.isAccessible("TPR11");
  }
  static PurchaseOrderReceiptMaintenanceModify_IsAccessible() {
    return this.isAccessible("TPR12");
  }
  static PurchaseOrderReceiptMaintenanceLineCancel_IsAccessible() {
    return this.isAccessible("TPR13");
  }
  //#endregion
  //#region Vendor Invoice
  static VendorInvoice_IsAccessible() {
    return this.isAccessible("VI000");
  }
  static VendorInvoiceCreate_IsAccessible() {
    return this.isAccessible("VI001");
  }
  static VendorInvoiceEdit_IsAccessible() {
    return this.isAccessible("VI002");
  }
  static VendorInvoiceView_IsAccessible() {
    return this.isAccessible("VI003");
  }
  static VendorInvoiceApprove_IsAccessible() {
    return this.isAccessible("VI004");
  }
  static VendorInvoiceCancel_IsAccessible() {
    return this.isAccessible("VI005");
  }
  static VendorInvoiceThreeWayCheckProcess_IsAccessible() {
    return this.isAccessible("VI006");
  }
  static VendorInvoiceUnApprove_IsAccessible() {
    return this.isAccessible("VI007");
  }
  static VendorInvoicePDFReport_IsAccessible() {
    return this.isAccessible("VI008");
  }
  static VendorInvoiceExcelReport_IsAccessible() {
    return this.isAccessible("VI009");
  }
  static VendorInvoiceMailReport_IsAccessible() {
    return this.isAccessible("VI010");
  }
  static VendorInvoiceModify_IsAccessible() {
    return this.isAccessible("VI011");
  }
  //#endregion
  //#endRegion
  //#region Accounts
  //#region Accounts Receivable
  static AccountReceivableMaintenance_IsAccessible() {
    return this.isAccessible("TAR00");
  }
  static AccountReceivableMaintenanceAdd_IsAccessible() {
    return this.isAccessible("TAR01");
  }
  static AccountReceivableMaintenanceEdit_IsAccessible() {
    return this.isAccessible("TAR02");
  }
  static AccountReceivableMaintenanceView_IsAccessible() {
    return this.isAccessible("TAR03");
  }
  static AccountReceivableMaintenanceApprove_IsAccessible() {
    return this.isAccessible("TAR04");
  }
  static AccountReceivableMaintenanceCancel_IsAccessible() {
    return this.isAccessible("TAR05");
  }
  static AccountReceivableMaintenanceReverse_IsAccessible() {
    return this.isAccessible("TAR06");
  }
  static AccountReceivableMaintenancePDFReport_IsAccessible() {
    return this.isAccessible("TAR07");
  }
  static AccountReceivableMaintenanceExcelReport_IsAccessible() {
    return this.isAccessible("TAR08");
  }
  static AccountReceivableMaintenanceSendMailReport_IsAccessible() {
    return this.isAccessible("TAR09");
  }
  static AccountReceivableCreateViaSalesInvoice_IsAccessible() {
    return this.isAccessible("TAR10");
  }
  static AccountReceivableCreateViaCreditmemo_IsAccessible() {
    return this.isAccessible("TAR11");
  }
  //#endregion
  //#region Credit Memo
  static CreditMemoMaintenance_IsAccessible() {
    return this.isAccessible("TCM00");
  }
  static CreditMemoMaintenanceAdd_IsAccessible() {
    return this.isAccessible("TCM01");
  }
  static CreditMemoMaintenanceEdit_IsAccessible() {
    return this.isAccessible("TCM02");
  }
  static CreditMemoMaintenanceView_IsAccessible() {
    return this.isAccessible("TCM03");
  }
  static CreditMemoMaintenanceApprove_IsAccessible() {
    return this.isAccessible("TCM04");
  }
  static CreditMemoMaintenanceUnApprove_IsAccessible() {
    return this.isAccessible("TCM05");
  }
  static CreditMemoMaintenanceCancel_IsAccessible() {
    return this.isAccessible("TCM06");
  }
  static CreditMemoMaintenancePDFReport_IsAccessible() {
    return this.isAccessible("TCM07");
  }
  static CreditMemoMaintenanceExcelReport_IsAccessible() {
    return this.isAccessible("TCM08");
  }
  static CreditMemoMaintenanceSendMailReport_IsAccessible() {
    return this.isAccessible("TCM09");
  }
  static CreditMemoMaintenanceAdjust_IsAccessible() {
    return this.isAccessible("TCM10");
  }
  static CreditMemoMaintenanceCustomerRefund_IsAccessible() {
    return this.isAccessible("TCM11");
  }
  static CreditMemoMaintenanceApproveAndPrintReport_IsAccessible() {
    return this.isAccessible("TCM12");
  }
  static CreditMemoMaintenanceApplyToInvoice_IsAccessible() {
    return this.isAccessible("TCM13");
  }
  //#endregion
  //#region Check Transaction
  static CheckTransactionMaintenance_IsAccessible() {
    return this.isAccessible("CHKT00");
  }
  static CheckTransactionCreate_IsAccessible() {
    return this.isAccessible("CHKT01");
  }
  static CheckTransactionEdit_IsAccessible() {
    return this.isAccessible("CHKT02");
  }
  static CheckTransactionView_IsAccessible() {
    return this.isAccessible("CHKT03");
  }
  static CheckTransactionApprove_IsAccessible() {
    return this.isAccessible("CHKT04");
  }
  static CheckTransactionPDFReport_IsAccessible() {
    return this.isAccessible("CHKT05");
  }
  static CheckTransactionExcelReport_IsAccessible() {
    return this.isAccessible("CHKT06");
  }
  static CheckTransactionSendReport_IsAccessible() {
    return this.isAccessible("CHKT07");
  }
  static CheckTransactionCancel_IsAccessible() {
    return this.isAccessible("CHKT08");
  }
  static CheckTransactionPrint_IsAccessible() {
    return this.isAccessible("CHKT09");
  }
  static CheckTransactionReprint_IsAccessible() {
    return this.isAccessible("CHKT10");
  }
  //# endregion
  //#region Check Transaction Print
  //#region Check Transaction Print
  static BatchCheckTransactionMaintenance_IsAccessible() {
    return this.isAccessible("CHKTP00");
  }
  static BatchCheckTransactionPDFReport_IsAccessible() {
    return this.isAccessible("CHKTP00");
  }
  static BatchCheckTransactionExcelReport_IsAccessible() {
    return this.isAccessible("CHKTP01");
  }
  static BatchCheckTransactionSendReport_IsAccessible() {
    return this.isAccessible("CHKTP02");
  }
  //#end region
  //#region Bank Adjustment
  static BankAdjustmentMaintenance_IsAccessible() {
    return this.isAccessible("BNKADJ00");
  }
  static BankAdjustmentCreate_IsAccessible() {
    return this.isAccessible("BNKADJ01");
  }
  static BankAdjustmentEdit_IsAccessible() {
    return this.isAccessible("BNKADJ02");
  }
  static BankAdjustmentView_IsAccessible() {
    return this.isAccessible("BNKADJ03");
  }
  static BankAdjustmentApproval_IsAccessible() {
    return this.isAccessible("BNKADJ04");
  }
  // #endregion
  //#region Deposit Module
  static DepositMaintenance_IsAccessible() {
    return this.isAccessible("DEPT00");
  }
  static DepositCreate_IsAccessible() {
    return this.isAccessible("DEPT01");
  }
  static DepositUpdate_IsAccessible() {
    return this.isAccessible("DEPT02");
  }
  static DepositView_IsAccessible() {
    return this.isAccessible("DEPT03");
  }
  static DepositApproval_IsAccessible() {
    return this.isAccessible("DEPT04");
  }
  static DepositUnApproval_IsAccessible() {
    return this.isAccessible("DEPT05");
  }
  static DepositCancel_IsAccessible() {
    return this.isAccessible("DEPT06");
  }
  static DepositPDFReport_IsAccessible() {
    return this.isAccessible("DEPT07");
  }
  static DepositExcelReport_IsAccessible() {
    return this.isAccessible("DEPT08");
  }
  static DepositMailReport_IsAccessible() {
    return this.isAccessible("DEPT09");
  }
  static DepositReversal_IsAccessible() {
    return this.isAccessible("DEPT10");
  }
  // #endregion
  //#region Letter Of Credits
  static LetterOfCreditMaintainance_IsAccessible() {
    return this.isAccessible("LOC00");
  }
  static LetterOfCreditCreation_IsAccessible() {
    return this.isAccessible("LOC01");
  }
  static LetterOfCreditUpdation_IsAccessible() {
    return this.isAccessible("LOC02");
  }
  static LetterOfCreditView_IsAccessible() {
    return this.isAccessible("LOC03");
  }
  static LetterOfCreditCancel_IsAccessible() {
    return this.isAccessible("LOC04");
  }
  static LetterOfCreditPDFReport_IsAccessible() {
    return this.isAccessible("LOC05");
  }
  static LetterOfCreditExcelReport_IsAccessible() {
    return this.isAccessible("LOC06");
  }
  static LetterOfCreditSendReport_IsAccessible() {
    return this.isAccessible("LOC07");
  }
  //#endRegion
  //#region CheckBounce
  static CheckBounceProcessMaintainance_IsAccessible() {
    return this.isAccessible("CBM00");
  }
  static CheckBounceProcessCreation_IsAccessible() {
    return this.isAccessible("CBM01");
  }
  static CheckBounceProcessUpdate_IsAccessible() {
    return this.isAccessible("CBM02");
  }
  static CheckBounceProcessView_IsAccessible() {
    return this.isAccessible("CBM03");
  }
  static CheckBounceProcessApproveIsAccessible() {
    return this.isAccessible("CBM04");
  }
  static CheckBounceProcessUnApproveIsAccessible() {
    return this.isAccessible("CBM05");
  }
  static CheckBounceProcessCancelIsAccessible() {
    return this.isAccessible("CBM06");
  }
  static CheckBounceProcessPDFReport_IsAccessible() {
    return this.isAccessible("CBM07");
  }
  static CheckBounceProcessExcelReport_IsAccessible() {
    return this.isAccessible("CBM08");
  }
  static CheckBounceProcessSendMail_IsAccessible() {
    return this.isAccessible("CBM09");
  }
  //#endRegion
  //#region Customer Return
  static CustomerReturnMaintenance_IsAccessible() {
    return this.isAccessible("MCRMOO");
  }
  static CustomerReturnCreation_IsAccessible() {
    return this.isAccessible("MCRMO1");
  }
  static CustomerReturnUpdation_IsAccessible() {
    return this.isAccessible("MCRMO2");
  }
  static CustomerReturnView_IsAccessible() {
    return this.isAccessible("MCRMO3");
  }
  static CustomerReturnApproval_IsAccessible() {
    return this.isAccessible("MCRMO4");
  }
  static CustomerReturnUnApproval_IsAccessible() {
    return this.isAccessible("MCRMO5");
  }
  static CustomerReturnCancellation_IsAccessible() {
    return this.isAccessible("MCRMO6");
  }
  static CustomerReturnPDFReport_IsAccessible() {
    return this.isAccessible("MCRMO7");
  }
  static CustomerReturnExcelReport_IsAccessible() {
    return this.isAccessible("MCRMO8");
  }
  static CustomerReturnSendMailReport_IsAccessible() {
    return this.isAccessible("MCRMO9");
  }
  static CustomerReturnAdjustment_IsAccessible() {
    return this.isAccessible("MCRMO10");
  }
  static CustomerReturnCustomerRefund_IsAccessible() {
    return this.isAccessible("MCRMO11");
  }
  static CustomerReturnApproveAndPrint_IsAccessible() {
    return this.isAccessible("MCRMO12");
  }
  //#endRegion
  //#region
  static PostDatedCheckEntryMaintenance_IsAccessible() {
    return this.isAccessible("PDCE00");
  }
  static PostDatedCheckEntryCreation_IsAccessible() {
    return this.isAccessible("PDCE01");
  }
  static PostDatedCheckEntryUpdation_IsAccessible() {
    return this.isAccessible("PDCE02");
  }
  static PostDatedCheckEntryView_IsAccessible() {
    return this.isAccessible("PDCE03");
  }
  static PostDatedCheckEntryApproval_IsAccessible() {
    return this.isAccessible("PDCE04");
  }
  static PostDatedCheckEntryCancellation_IsAccessible() {
    return this.isAccessible("PDCE05");
  }
  static PostDatedCheckEntryUnApproval_IsAccessible() {
    return this.isAccessible("PDCE06");
  }
  static PostDatedCheckEntryClose_IsAccessible() {
    return this.isAccessible("PDCE07");
  }
  static PostDatedCheckEntryPDFReport_IsAccessible() {
    return this.isAccessible("PDCE08");
  }
  static PostDatedCheckEntryExcelReport_IsAccessible() {
    return this.isAccessible("PDCE09");
  }
  static PostDatedCheckEntrySendReport_IsAccessible() {
    return this.isAccessible("PDCE10");
  }
  static PostDatedCheckEntryModify_IsAccessible() {
    return this.isAccessible("PDCE11");
  }
  //#endregion
  //#endRegion
  //#region Logistic
  //#region Logistic Order
  static LogesticOrder_IsAccessible() {
    return this.isAccessible("LO00");
  }
  static LogisticOrderCreation_IsAccessible() {
    return this.isAccessible("LO01");
  }
  static LogisticOrderUpdation_IsAccessible() {
    return this.isAccessible("LO02");
  }
  static LogisticOrderView_IsAccessible() {
    return this.isAccessible("LO03");
  }
  static LogisticOrderApproval_IsAccessible() {
    return this.isAccessible("LO04");
  }
  static LogisticOrderUnApproval_IsAccessible() {
    return this.isAccessible("LO05");
  }
  static LogisticOrderCancel_IsAccessible() {
    return this.isAccessible("LO06");
  }
  static LogisticOrderClose_IsAccessible() {
    return this.isAccessible("LO07");
  }
  static LogisticOrderPDFReport_IsAccessible() {
    return this.isAccessible("LO08");
  }
  static LogisticOrderExcelReport_IsAccessible() {
    return this.isAccessible("LO09");
  }
  static LogisticOrderMailSend_IsAccessible() {
    return this.isAccessible("LO10");
  }
  static LogisticOrderUpdationAfterApproval_IsAccessible() {
    return this.isAccessible("LO11");
  }
  static LogisticOrderLineCancel_IsAccessible() {
    return this.isAccessible("LO12");
  }
  // #endregion
  //#region Logistic Receipt
  static LogesticReceipt_IsAccessible() {
    return this.isAccessible("LR00");
  }
  static LogisticOrderReceiptCreation_IsAccessible() {
    return this.isAccessible("LR01");
  }
  static LogisticOrderReceiptUpdation_IsAccessible() {
    return this.isAccessible("LR02");
  }
  static LogisticOrderReceiptView_IsAccessible() {
    return this.isAccessible("LR03");
  }
  static LogisticOrderReceiptApproval_IsAccessible() {
    return this.isAccessible("LR04");
  }
  static LogisticOrderReceiptUnApproval_IsAccessible() {
    return this.isAccessible("LR05");
  }
  static LogisticOrderReceiptConform_IsAccessible() {
    return this.isAccessible("LR06");
  }
  static LogisticOrderReceiptClose_IsAccessible() {
    return this.isAccessible("LR07");
  }
  static LogisticOrderReceiptCancel_IsAccessible() {
    return this.isAccessible("LR08");
  }
  static LogisticOrderReceiptPDFReport_IsAccessible() {
    return this.isAccessible("LR09");
  }
  static LogisticOrderReceiptExcelReport_IsAccessible() {
    return this.isAccessible("LR10");
  }
  static LogisticOrderReceiptSendMail_IsAccessible() {
    return this.isAccessible("LR11");
  }
  static LogisticOrderReceiptModify_IsAccessible() {
    return this.isAccessible("LR12");
  }
  static LogisticOrderReceiptLineCancel_IsAccessible() {
    return this.isAccessible("LR13");
  }
  // #endregion
  //#region Pallet BarCode Generator
  static PalletBarCodeGeneratorModule_IsAccessible() {
    return this.isAccessible("PBCG00");
  }
  static PalletBarCodeGeneratorModulePDFReport_IsAccessible() {
    return this.isAccessible("PBCG01");
  }
  static PalletBarCodeGeneratorModuleExcelReport_IsAccessible() {
    return this.isAccessible("PBCG02");
  }
  //#endregion
  //#endRegion
  //#region Inventory
  //#region InventoryAdjustment
  static InventoryAdjustmentMaintenance_IsAccessible() {
    return this.isAccessible("IIA00");
  }
  static InventoryAdjustmentMaintenanceCreate_IsAccessible() {
    return this.isAccessible("IIA01");
  }
  static InventoryAdjustmentMaintenanceEdit_IsAccessible() {
    return this.isAccessible("IIA02");
  }
  static InventoryAdjustmentMaintenanceView_IsAccessible() {
    return this.isAccessible("IIA03");
  }
  static InventoryAdjustmentMaintenanceCancel_IsAccessible() {
    return this.isAccessible("IIA04");
  }
  //#endregion
  //#region InventoryTransfer
  static InventoryTransferMaintenance_IsAccessible() {
    return this.isAccessible("ILT00");
  }
  static InventoryTransferMaintenanceCreate_IsAccessible() {
    return this.isAccessible("ILT01");
  }
  static InventoryTransferMaintenanceEdit_IsAccessible() {
    return this.isAccessible("ILT02");
  }
  static InventoryTransferMaintenanceView_IsAccessible() {
    return this.isAccessible("ILT03");
  }
  static InventoryTransferMaintenanceCancel_IsAccessible() {
    return this.isAccessible("ILT04");
  }
  //#endRegion
  // #region  Print Roll
  static PrintRollBarCodeMaintenance_IsAccessible() {
    return this.isAccessible("PRBC01");
  }
  static PrintRollBarCodeMaintenancePDFReport_IsAccessible() {
    return this.isAccessible("PRBC02");
  }
  //#endregion
  //#region Print InTransit RollSKU BARCode Print
  static PrintInTransitRollSKUBarCodeMaintenance_IsAccessible() {
    return this.isAccessible("PINRS01");
  }
  static PrintInTransitRollSKUBarCodePDFReport_IsAccessible() {
    return this.isAccessible("PINRS02");
  }
  static PrintInTransitRollSKUBarCodeExcelReport_IsAccessible() {
    return this.isAccessible("PINRS03");
  }
  static PrintInTransitRollSKUBarCodeSendMailReport_IsAccessible() {
    return this.isAccessible("PINRS04");
  }
  //#endregion
  //#region Mass Inventory Transfer
  static MassInventoryTransfer_IsAccessible() {
    return this.isAccessible("MIT00");
  }
  static MassInventoryTransferCreate_IsAccessible() {
    return this.isAccessible("MIT01");
  }
  //#endregion
  //#rgion Manual Inventory Allocation
  static CustomerAllocationMaintenance_IsAccessible() {
    return this.isAccessible("CUSALL00");
  }
  static CustomerAllocationMaintenanceCreate_IsAccessible() {
    return this.isAccessible("CUSALL01");
  }
  static CustomerAllocationMaintenanceEdit_IsAccessible() {
    return this.isAccessible("CUSALL02");
  }
  static CustomerAllocationMaintenanceView_IsAccessible() {
    return this.isAccessible("CUSALL03");
  }
  static CustomerAllocationMaintenanceCancel_IsAccessible() {
    return this.isAccessible("CUSALL04");
  }
  static CustomerAllocationMaintenancPDFReport_IsAccessible() {
    return this.isAccessible("CUSALL05");
  }
  static CustomerAllocationMaintenancExcelReport_IsAccessible() {
    return this.isAccessible("CUSALL06");
  }
  static CustomerAllocationMaintenancSendMailReport_IsAccessible() {
    return this.isAccessible("CUSALL07");
  }
  //#endRegion
  //#region Roll data conversion
  static RollDataConversionMaintenance_IsAccessible() {
    return this.isAccessible("RDCO00");
  }
  static RollDataConversionMaintenanceCreate_IsAccessible() {
    return this.isAccessible("RDCO01");
  }
  static RollDataConversionMaintenanceEdit_IsAccessible() {
    return this.isAccessible("RDCO02");
  }
  static RollDataConversionMaintenanceView_IsAccessible() {
    return this.isAccessible("RDCO03");
  }
  static RollDataConversionMaintenanceDelete_IsAccessible() {
    return this.isAccessible("RDCO04");
  }
  //#endregion
  //#rgion Physical Inventory Adjustments
  static PhysicalInventoryAdjustmentMaintainance_IsAccessible() {
    return this.isAccessible("PIA00");
  }
  static PhysicalInventoryAdjustmentCreation_IsAccessible() {
    return this.isAccessible("PIA01");
  }
  static PhysicalInventoryAdjustmentUpdation_IsAccessible() {
    return this.isAccessible("PIA02");
  }
  static PhysicalInventoryAdjustmentView_IsAccessible() {
    return this.isAccessible("PIA03");
  }
  static PhysicalInventoryAdjustmentCancel_IsAccessible() {
    return this.isAccessible("PIA04");
  }
  //#endRegion
  //#rgion Roll Inventory
  static SkuBatchInventoryMaintenance_IsAccessible() {
    return this.isAccessible("ROINV00");
  }
  static SkuBatchInventoryMaintenanceCreate_IsAccessible() {
    return this.isAccessible("ROINV01");
  }
  static SkuBatchInventoryMaintenanceEdit_IsAccessible() {
    return this.isAccessible("ROINV02");
  }
  static SkuBatchInventoryMaintenanceView_IsAccessible() {
    return this.isAccessible("ROINV03");
  }
  static SkuBatchInventoryMaintenanceDelete_IsAccessible() {
    return this.isAccessible("ROINV04");
  }
  //#endRegion
  //#endregion
  //#region Job
  //#region Web Item Export
  static WebItemExport_IsAccessible() {
    return this.isAccessible("WIE00");
  }
  // #endregion
  //#region Web Item Import
  static WebItemImport_IsAccessible() {
    return this.isAccessible("WII00");
  }
  // #endregion
  //#region Web SKU Inventory Export
  static WebSKUInventoryExport_IsAccessible() {
    return this.isAccessible("WIEXP01");
  }
  // #endregion
  //#region Ecom Job Status Details
  static EcomJobStatusDetails_IsAccessible() {
    return this.isAccessible("JOBSTS00");
  }
  // #endregion
  //#region Ecom Web Order Status Details
  static EcomWebOrderStatusDetails_IsAccessible() {
    return this.isAccessible("WOS01");
  }
  // #endregion
  //#region  Web Fabric Excel to ERP Import
  static WebFabricExcelToERPImport_IsAccessible() {
    return this.isAccessible("WFEEI00");
  }
  // #endregion
  //#endRegion
  //#region Inquiry
  //# All fabric ats inquiry
  static AllFabricATSInquiry_IsAccessible() {
    return this.isAccessible("IN0010");
  }
  static AllFabricATSInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IN0011");
  }
  static AllFabricATSInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IN0012");
  }
  static AllFabricATSInquiryMailReport_IsAccessible() {
    return this.isAccessible("IN0013");
  }
  static AllFabricATSInquiryPOInputExcel_IsAccessible() {
    return this.isAccessible("IN0014");
  }
  //#endRegion
  //#region Fabric Statistics Inquiry
  static FabricStatisticsInquiry_IsAccessible() {
    return this.isAccessible("IN0370");
  }
  static FabricStatisticsInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IN0371");
  }
  static FabricStatisticsInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IN0372");
  }
  static FabricStatisticsInquiryMail_IsAccessible() {
    return this.isAccessible("IN0373");
  }
  //#endregion
  //#region PrintOut Track Inquiry
  static PrintOutTrackInquiry_IsAccessible() {
    return this.isAccessible("PTI00");
  }
  static PrintOutTrackInquiryPDFReport_IsAccessible() {
    return this.isAccessible("PTI01");
  }
  static PrintOutTrackInquiryExcelReport_IsAccessible() {
    return this.isAccessible("PTI02");
  }
  static PrintOutTrackInquiryMailReport_IsAccessible() {
    return this.isAccessible("PTI03");
  }
  //#endregion
  //#region FabricStyle PriceList PriceCost Inquiry
  static FabricStylePriceListPriceCostInquiry_IsAccessible() {
    return this.isAccessible("INPC00");
  }
  static FabricStylePriceListPriceCostInquiryPDFReport_IsAccessible() {
    return this.isAccessible("INPC01");
  }
  static FabricStylePriceListPriceCostInquiryExcelReport_IsAccessible() {
    return this.isAccessible("INPC02");
  }
  static FabricStylePriceListPriceCostInquiryMailReport_IsAccessible() {
    return this.isAccessible("INPC03");
  }
  //#endregion
  //# All fabric weekly Monthly ats inquiry
  static FabricWeeklyMonthlyATSInquiry_IsAccessible() {
    return this.isAccessible("INFMATS0");
  }
  static FabricWeeklyMonthlyATSPdfReport_IsAccessible() {
    return this.isAccessible("INFMATS1");
  }
  static FabricWeeklyMonthlyATSExcelReport_IsAccessible() {
    return this.isAccessible("INFMATS2");
  }
  static FabricWeeklyMonthlyATSMailReport_IsAccessible() {
    return this.isAccessible("INFMATS3");
  }
  //#endRegion
  //# All fabric Customer ats inquiry
  static AllFabricCustomerATSInquiry_IsAccessible() {
    return this.isAccessible("IAFCATS0");
  }
  static AllFabricCustomerATSInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IAFCATS1");
  }
  static AllFabricCustomerATSInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IAFCATS2");
  }
  static AllFabricCustomerATSInquirySendMailReport_IsAccessible() {
    return this.isAccessible("IAFCATS3");
  }
  //#endRegion
  //# fabric Customer   ats inquiry
  static CustomerFabricATSInquiry_IsAccessible() {
    return this.isAccessible("ICFATS00");
  }
  static CustomerFabricATSInquiryPDFReport_IsAccessible() {
    return this.isAccessible("ICFATS01");
  }
  static CustomerFabricATSInquiryExcelReport_IsAccessible() {
    return this.isAccessible("ICFATS02");
  }
  static CustomerFabricATSInquirySendMailReport_IsAccessible() {
    return this.isAccessible("ICFATS03");
  }
  //#endRegion
  //#region	Mail Track Inquiry
  static MailTrackInquiry_IsAccessible() {
    return this.isAccessible("IN0020");
  }
  static MailTrackInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IN0021");
  }
  static MailTrackInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IN0022");
  }
  static MailTrackInquirySendMailReport_IsAccessible() {
    return this.isAccessible("IN0023");
  }
  //#endregion
  //#region OnOrder
  // #region Customer OnOrder inquiry
  static CustomerOnOrderInquiry_IsAccessible() {
    return this.isAccessible("IN0070");
  }
  static CustomerOnOrderInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IN0071");
  }
  static CustomerOnOrderInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IN0072");
  }
  static CustomerOnOrderInquirySendMailReport_IsAccessible() {
    return this.isAccessible("IN0073");
  }
  // # endRegion
  //#region VendorOnOrder
  static VendorOnOrderInquiry_IsAccessible() {
    return this.isAccessible("IN0060");
  }
  static VendorOnOrderInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IN0061");
  }
  static VendorOnOrderInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IN0062");
  }
  static VendorOnOrderInquiryMailReport_IsAccessible() {
    return this.isAccessible("IN0063");
  }
  //#endregion
  //#region FabricOnOrder Inquiry
  static FabricOnOrderInquiry_IsAccessible() {
    return this.isAccessible("IN0080");
  }
  static FabricOnOrderInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IN0081");
  }
  static FabricOnOrderInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IN0082");
  }
  static FabricOnOrderInquiryMailReport_IsAccessible() {
    return this.isAccessible("IN0083");
  }
  // #endregion
  //#endRegion
  //#region sales
  //#region Custoemr Sales Details inquiry
  static CustomerSalesDetailsInquiry_IsAccessible() {
    return this.isAccessible("IN0001");
  }
  static CustomerSalesDetailsInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IN0002");
  }
  static CustomerSalesDetailsInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IN0003");
  }
  static CustomerSalesDetailsInquirySendMailReport_IsAccessible() {
    return this.isAccessible("IN0004");
  }
  //#endregion
  //#region Customer Sales Order And Invoice Detail Inquiry
  static CustomerSalesOrderAndInvoiceDetailInquiry_IsAccessible() {
    return this.isAccessible("INCSID00");
  }
  static CustomerSalesOrderAndInvoiceDetailInquiryPDFReport_IsAccessible() {
    return this.isAccessible("INCSID01");
  }
  static CustomerSalesOrderAndInvoiceDetailInquiryExcelReport_IsAccessible() {
    return this.isAccessible("INCSID02");
  }
  static CustomerSalesOrderAndInvoiceDetailInquiryMailReport_IsAccessible() {
    return this.isAccessible("INCSID03");
  }
  //#endregion
  //#region Most Recent Customer Sales Detail Inquiry
  static MostRecentCustomerSalesDetailInquiry_IsAccessible() {
    return this.isAccessible("INMRCI00");
  }
  static MostRecentCustomerSalesDetailInquiryPDFReport_IsAccessible() {
    return this.isAccessible("INMRCI01");
  }
  static MostRecentCustomerSalesDetailInquiryExcelReport_IsAccessible() {
    return this.isAccessible("INMRCI02");
  }
  static MostRecentCustomerSalesDetailInquiryMailReport_IsAccessible() {
    return this.isAccessible("INMRCI03");
  }
  //#endregion
  //#region Invoice FabricStyle Yearly Inquiry
  static InvoiceFabricStyleYearlyInquiry_IsAccessible() {
    return this.isAccessible("IIFSYS00");
  }
  static InvoiceFabricStyleYearlyInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IIFSYS01");
  }
  static InvoiceFabricStyleYearlyInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IIFSYS02");
  }
  static InvoiceFabricStyleYearlyInquiryMail_IsAccessible() {
    return this.isAccessible("IIFSYS03");
  }
  //#endregion
  //#region Invoice Register inquiry
  static InvoiceRegisterInquiry_IsAccessible() {
    return this.isAccessible("IN0100");
  }
  static InvoiceRegisterInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IN0101");
  }
  static InvoiceRegisterInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IN0102");
  }
  static InvoiceRegisterInquirySendMailReport_IsAccessible() {
    return this.isAccessible("IN0103");
  }
  // #endregion
  //#endRegion
  //#region infolist
  //#region Fabric Info Inventory inquiry
  static FabricStyleValuationInfoInquiry_IsAccessible() {
    return this.isAccessible("INFV00");
  }
  static FabricStyleValuationInfoInquiryPDFReport_IsAccessible() {
    return this.isAccessible("INFV01");
  }
  static FabricStyleValuationInfoInquiryExcelReport_IsAccessible() {
    return this.isAccessible("INFV02");
  }
  static FabricStyleValuationInfoInquirySendMailReport_IsAccessible() {
    return this.isAccessible("INFV03");
  }
  // #endregion
  //#region fabricStyleSKU inquiry
  static FabricStyleSKU_IsAccessible() {
    return this.isAccessible("INFSKU0");
  }
  static fabricStyleSKUPDFReport_IsAccessible() {
    return this.isAccessible("INFSKU1");
  }
  static fabricStyleSKUExcelReport_IsAccessible() {
    return this.isAccessible("INFSKU2");
  }
  static fabricStyleSKUMailReport_IsAccessible() {
    return this.isAccessible("INFSKU3");
  }
  // #endregion
  // #region Customer Info Inventory inquiry
  static CustomerInfoInquiry_IsAccessible() {
    return this.isAccessible("INCL00");
  }
  static CustomerInfoInquiryPDFReport_IsAccessible() {
    return this.isAccessible("INCL01");
  }
  static CustomerInfoInquiryExcelReport_IsAccessible() {
    return this.isAccessible("INCL02");
  }
  static CustomerInfoSendMailReport_IsAccessible() {
    return this.isAccessible("INCL03");
  }
  // #endregion
  // #region Vendor Info Inventory inquiry
  static VendorInfoInquiry_IsAccessible() {
    return this.isAccessible("INVNF00");
  }
  static VendorInfoInquiryPDFReport_IsAccessible() {
    return this.isAccessible("INVNF01");
  }
  static VendorInfoInquiryExcelReport_IsAccessible() {
    return this.isAccessible("INVNF02");
  }
  static VendorInfoSendMailReport_IsAccessible() {
    return this.isAccessible("INVNF03");
  }
  //#endregion
  // #region Product Availability  inquiry
  static ProductAvailabilityInquiry_IsAccessible() {
    return this.isAccessible("INPDA00");
  }
  static ProductAvailabilityInquiryPDFReport_IsAccessible() {
    return this.isAccessible("INPDA01");
  }
  static ProductAvailabilityInquiryExcelReport_IsAccessible() {
    return this.isAccessible("INPDA02");
  }
  static ProductAvailabilitySendMailReport_IsAccessible() {
    return this.isAccessible("INPDA03");
  }
  // #endregion
  //#endRegion
  //#region Inventory
  //#region Web Inventory Inquiry
  static WebInventoryMaintenance_IsAccessible() {
    return this.isAccessible("IWEINV00");
  }
  static WebInventoryMaintenancePDFReport_IsAccessible() {
    return this.isAccessible("IWEINV01");
  }
  static WebInventoryMaintenanceExcelReport_IsAccessible() {
    return this.isAccessible("IWEINV02");
  }
  static WebInventoryMaintenanceMailReport_IsAccessible() {
    return this.isAccessible("IWEINV03");
  }
  //#endRegion
  //#region	SkuInventorySkuBased
  static SkuInventorySkuBasedInquiry_IsAccessible() {
    return this.isAccessible("IN0030");
  }
  static SkuInventorySkuBasedInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IN0031");
  }
  static SkuInventorySkuBasedInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IN0032");
  }
  static SkuInventorySkuBasedInquirySendMailReport_IsAccessible() {
    return this.isAccessible("IN0033");
  }
  //#endregion
  //#region Item Sku Batch Inventory inquiry
  static SkuBatchInventoryInquiry_IsAccessible() {
    return this.isAccessible("IN0040");
  }
  static SkuBatchInventoryInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IN0041");
  }
  static SkuBatchInventoryInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IN0042");
  }
  static SkuBatchInventoryInquiryendMailReport_IsAccessible() {
    return this.isAccessible("IN0043");
  }
  //#end region
  //# SkuBatchInventoryTrackInquiry
  static SkuInventoryTrackInquiry_IsAccessible() {
    return this.isAccessible("ISIT00");
  }
  static SkuInventoryTrackInquiryPDFReport_IsAccessible() {
    return this.isAccessible("ISIT01");
  }
  static SkuInventoryTrackInquiryExcelReport_IsAccessible() {
    return this.isAccessible("ISIT02");
  }
  static SkuInventoryTrackInquiryMailReport_IsAccessible() {
    return this.isAccessible("ISIT03");
  }
  //# endRegion
  //# SkuBatchInventoryTrackInquiry
  static SkuBatchInventoryTrackInquiry_IsAccessible() {
    return this.isAccessible("IN0050");
  }
  static SkuBatchInventoryTrackInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IN0051");
  }
  static SkuBatchInventoryTrackInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IN0052");
  }
  static SkuBatchInventoryTrackInquiryMailReport_IsAccessible() {
    return this.isAccessible("IN0053");
  }
  //# endRegion
  //#region	Obselete Inventory Inquiry
  static ObseleteInventoryInquiry_IsAccessible() {
    return this.isAccessible("INC050");
  }
  static ObseleteInventoryInquiryPDFReport_IsAccessible() {
    return this.isAccessible("INC051");
  }
  static ObseleteInventoryInquiryExcelReport_IsAccessible() {
    return this.isAccessible("INC052");
  }
  static ObseleteInventoryInquiryMail_IsAccessible() {
    return this.isAccessible("INC053");
  }
  static SkuInventoryInquiryPrint_IsAccessible() {
    return this.isAccessible("INC054");
  }
  //#endregion
  // #region Bin Inventory inquiry
  static BinInventoryInquiry_IsAccessible() {
    return this.isAccessible("INBINV00");
  }
  static BinInventoryInquiryPDFReport_IsAccessible() {
    return this.isAccessible("INBINV01");
  }
  static BinInventoryInquiryExcelReport_IsAccessible() {
    return this.isAccessible("INBINV02");
  }
  static BinInventoryInquirySendMailReport_IsAccessible() {
    return this.isAccessible("INBINV03");
  }
  static BinInventoryForInventoryAdjustmentSendMailReport_IsAccessible() {
    return this.isAccessible("INBINV04");
  }
  static BinInventoryForInventoryAdjustmentExcelReport_IsAccessible() {
    return this.isAccessible("INBINV05");
  }
  //#endregion
  //#region Bin Summary Inventory
  static SkuBatchInventoryBinSummaryInquiry_IsAccessible() {
    return this.isAccessible("ISBIIBS0");
  }
  static SkuBatchInventoryBinSummaryInquiryPDFReport_IsAccessible() {
    return this.isAccessible("ISBIIBS1");
  }
  static SkuBatchInventoryBinSummaryInquiryExcelReport_IsAccessible() {
    return this.isAccessible("ISBIIBS2");
  }
  static SkuBatchInventoryBinSummaryInquiryMailReport_IsAccessible() {
    return this.isAccessible("ISBIIBS3");
  }
  //#endRegion
  //#region SKU Inventory Lot Based
  static FabricStyleInventoryLotBasedInquiry_IsAccessible() {
    return this.isAccessible("ISILB00");
  }
  static FabricStyleInventoryLotBasedInquiryPDFReport_IsAccessible() {
    return this.isAccessible("ISILB01");
  }
  static FabricStyleInventoryLotBasedInquiryExcelReport_IsAccessible() {
    return this.isAccessible("ISILB02");
  }
  static FabricStyleInventoryLotBasedInquirySendMailReport_IsAccessible() {
    return this.isAccessible("ISILB03");
  }
  //#endRegion
  //#region Physical Verification Track
  static SkuBatchInventoryPhysicalVerificationInquiry_IsAccessible() {
    return this.isAccessible("INSBI00");
  }
  static SkuBatchInventoryPhysicalVerificationInquiryPDFReport_IsAccessible() {
    return this.isAccessible("INSBI01");
  }
  static SkuBatchInventoryPhysicalVerificationInquiryExcelReport_IsAccessible() {
    return this.isAccessible("INSBI02");
  }
  static SkuBatchInventoryPhysicalVerificationInquirySendMailReport_IsAccessible() {
    return this.isAccessible("INSBI03");
  }
  //#endRegion
  //#region Holding WareHouse Inventory
  static HoldingWareHouseInventoryInquiry_IsAccessible() {
    return this.isAccessible("IHWI00");
  }
  static HoldingWareHouseInventoryInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IHWI01");
  }
  static HoldingWareHouseInventoryInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IHWI02");
  }
  static HoldingWareHouseInventoryInquirySendMailReport_IsAccessible() {
    return this.isAccessible("IHWI03");
  }
  static HoldingWareHouseInventoryAdjustmentExcelReport_IsAccessible() {
    return this.isAccessible("IHWI04");
  }
  static HoldingWareHouseInventoryTransferExcelReport_IsAccessible() {
    return this.isAccessible("IHWI05");
  }
  //#endRegion
  //#region FabricStyle Inventory Valuation Info
  static FabricStyleInventoryValuationInfosInquiry_IsAccessible() {
    return this.isAccessible("INFVI00");
  }
  static FabricStyleInventoryValuationInfosInquiryPDFReport_IsAccessible() {
    return this.isAccessible("INFVI01");
  }
  static FabricStyleInventoryValuationInfosInquiryExcelReport_IsAccessible() {
    return this.isAccessible("INFVI02");
  }
  static FabricStyleInventoryValuationInfosInquirySendMailReport_IsAccessible() {
    return this.isAccessible("INFVI03");
  }
  //#endRegion
  //#region Customer Allocation Intransit Info
  static CustomerAllocationInTransitInfosInquiry_IsAccessible() {
    return this.isAccessible("ICATI00");
  }
  static CustomerAllocationInTransitInfosInquiryPDFReport_IsAccessible() {
    return this.isAccessible("ICATI01");
  }
  static CustomerAllocationInTransitInfosInquiryExcelReport_IsAccessible() {
    return this.isAccessible("ICATI02");
  }
  static CustomerAllocationInTransitInfosInquirySendMailReport_IsAccessible() {
    return this.isAccessible("ICATI03");
  }
  //#endRegion
  //#region Inventory Adjustment History Inquiry
  static InventoryAdjustmentHistoryInquiry_IsAccessible() {
    return this.isAccessible("IIAH00");
  }
  static InventoryAdjustmentHistoryInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IIAH01");
  }
  static InventoryAdjustmentHistoryInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IIAH02");
  }
  static InventoryAdjustmentHistoryInquiryMailReport_IsAccessible() {
    return this.isAccessible("IIAH02");
  }
  //#endregion
  //#endRegion
  //#region Sales
  //#region	Sales Order Register
  static SalesOrderRegisterInquiry_IsAccessible() {
    return this.isAccessible("IN0110");
  }
  static SalesOrderRegisterInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IN0111");
  }
  static SalesOrderRegisterInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IN0112");
  }
  static SalesOrderRegisterInquirySendMailReport_IsAccessible() {
    return this.isAccessible("IN0113");
  }
  //#endregion
  //#region	Sales Back Orders
  static SalesBackOrderInquiry_IsAccessible() {
    return this.isAccessible("IN0130");
  }
  static SalesBackOrderInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IN0131");
  }
  static SalesBackOrderInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IN0132");
  }
  static SalesBackOrderInquirySendMailReport_IsAccessible() {
    return this.isAccessible("IN0133");
  }
  //#endregion
  //#region	Customer Service SalesOrder Inquiry
  static CustomerServiceSalesOrderInquiry_IsAccessible() {
    return this.isAccessible("IN0360");
  }
  static CustomerServiceSalesOrderPDFReport_IsAccessible() {
    return this.isAccessible("IN0361");
  }
  static CustomerServiceSalesOrderExcelReport_IsAccessible() {
    return this.isAccessible("IN0362");
  }
  static CustomerServiceSalesOrderMail_IsAccessible() {
    return this.isAccessible("IN0363");
  }
  //#endregion
  //#region	Customer Service Inquiry
  static CustomerServiceInquiry_IsAccessible() {
    return this.isAccessible("IN0140");
  }
  static CustomerServiceInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IN0141");
  }
  static CustomerServiceInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IN0142");
  }
  static CustomerServiceInquirySendMailReport_IsAccessible() {
    return this.isAccessible("IN0143");
  }
  //#endregion
  //#region	Picked & NotInvoiced List Inquiry
  static PickedNotInvoicedListInquiry_IsAccessible() {
    return this.isAccessible("IN0150");
  }
  static PickedNotInvoicedListInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IN0151");
  }
  static PickedNotInvoicedListInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IN0152");
  }
  static PickedNotInvoicedListInquirySendMailReport_IsAccessible() {
    return this.isAccessible("IN0153");
  }
  //#endregion
  //#region	Invoiced & NotApproved List Inquiry
  static InvoicedNotApprovedListInquiry_IsAccessible() {
    return this.isAccessible("IN0160");
  }
  static InvoicedNotApprovedListInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IN0161");
  }
  static InvoicedNotApprovedListInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IN0162");
  }
  static InvoicedNotApprovedListInquirySendMailReport_IsAccessible() {
    return this.isAccessible("IN0163");
  }
  //#endregion
  //#region	UPS Pickup SummaryReport
  static UPSPickupSummeryInquiry_IsAccessible() {
    return this.isAccessible("IN0170");
  }
  static UPSPickupSummeryInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IN0171");
  }
  static UPSPickupSummeryInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IN0172");
  }
  static UPSPickupSummeryInquirySendMailReport_IsAccessible() {
    return this.isAccessible("IN0173");
  }
  //#endregion
  //#region Open PickTicket
  static OpenPickTicketInquiry_IsAccessible() {
    return this.isAccessible("IOPT00");
  }
  static OpenPickTicketInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IOPT01");
  }
  static OpenPickTicketInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IOPT02");
  }
  static OpenPickTicketInquirySendMailReport_IsAccessible() {
    return this.isAccessible("IOPT03");
  }
  //#endRegion
  //#region PickTicket Picker Detail
  static PickTicketPickerDetailListInquiry_IsAccessible() {
    return this.isAccessible("IPTPD00");
  }
  static PickTicketPickerDetailListInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IPTPD01");
  }
  static PickTicketPickerDetailListInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IPTPD02");
  }
  static PickTicketPickerDetailListInquirySendMailReport_IsAccessible() {
    return this.isAccessible("MLOG03");
  }
  //#endRegion
  //#region Picked And Shipped list
  static PickedandShippedListInquiry_IsAccessible() {
    return this.isAccessible("IPASL00");
  }
  static PickedandShippedListInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IPASL01");
  }
  static PickedandShippedListInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IPASL02");
  }
  static PickedandShippedListInquirySendMailReport_IsAccessible() {
    return this.isAccessible("IPASL03");
  }
  //#endRegion
  //#region salesOrder Register Details

  static SalesOrderRegisterDetailsInquiry_IsAccessible() {
    return this.isAccessible("ISORD00");
  }
  static SalesOrderRegisterDetailsInquiryPDFReport_IsAccessible() {
    return this.isAccessible("ISORD01");
  }
  static SalesOrderRegisterDetailsInquiryExcelReport_IsAccessible() {
    return this.isAccessible("ISORD02");
  }
  static SalesOrderRegisterDetailsInquirySendMailReport_IsAccessible() {
    return this.isAccessible("ISORD03");
  }
  //#endRegion
  //#region SalesOrder Cancel Details
  static SalesOrderLineCancelDetailsInquiry_IsAccessible() {
    return this.isAccessible("ISOLCD00");
  }
  static SalesOrderLineCancelDetailsInquiryPDFReport_IsAccessible() {
    return this.isAccessible("ISOLCD01");
  }
  static SalesOrderLineCancelDetailsInquiryExcelReport_IsAccessible() {
    return this.isAccessible("ISOLCD02");
  }
  static SalesOrderLineCancelDetailsInquirySendMailReport_IsAccessible() {
    return this.isAccessible("ISOLCD03");
  }
  //#endRegion
  //#region Booking Report
  static BookingReportInquiry_IsAccessible() {
    return this.isAccessible("IBKR00");
  }
  static BookingReportInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IBKR01");
  }
  static BookingReportInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IBKR02");
  }
  static BookingReportInquirySendMailReport_IsAccessible() {
    return this.isAccessible("IBKR03");
  }
  //#endRegion
  //#region Shipping Report
  static ShippingReportInquiry_IsAccessible() {
    return this.isAccessible("ISPR00");
  }
  static ShippingReportInquiryPDFReport_IsAccessible() {
    return this.isAccessible("ISPR01");
  }
  static ShippingReportInquiryExcelReport_IsAccessible() {
    return this.isAccessible("ISPR02");
  }
  static ShippingReportInquirySendMailReport_IsAccessible() {
    return this.isAccessible("ISPR03");
  }
  //#endRegion
  //#region SalesCommission
  static SalesPersonCommissionInquiry_IsAccessible() {
    return this.isAccessible("ISPC00");
  }
  static SalesPersonCommissionInquiryPDFReport_IsAccessible() {
    return this.isAccessible("ISPC01");
  }
  static SalesPersonCommissionInquiryExcelReport_IsAccessible() {
    return this.isAccessible("ISPC02");
  }
  static SalesPersonCommissionSendMailReport_IsAccessible() {
    return this.isAccessible("ISPC03");
  }
  //#endRegion
  //#region Return SalesCommission
  static ReturnSalesPersonCommissionInquiry_IsAccessible() {
    return this.isAccessible("IRSPC00");
  }
  static ReturnSalesPersonCommissionInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IRSPC01");
  }
  static ReturnSalesPersonCommissionInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IRSPC02");
  }
  static ReturnSalesPersonCommissionSendMailReport_IsAccessible() {
    return this.isAccessible("IRSPC03");
  }
  //#endRegion
  //#region Customer And Fabric Sales
  static CustomerAndFabricSalesInquiry_IsAccessible() {
    return this.isAccessible("ICAFS00");
  }
  static CustomerAndFabricSalesInquiryPDFReport_IsAccessible() {
    return this.isAccessible("ICAFS01");
  }
  static CustomerAndFabricSalesInquiryExcelReport_IsAccessible() {
    return this.isAccessible("ICAFS02");
  }
  static CustomerAndFabricSalesInquirySendMailReport_IsAccessible() {
    return this.isAccessible("ICAFS03");
  }
  //#endRegion
  //#endRegion
  //#region SalesAnalysis
  //#reagion FabricStyle Sales
  static FabricStyleSalesInquiry_IsAccessible() {
    return this.isAccessible("IN0090");
  }
  static FabricStyleSalesInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IN0091");
  }
  static FabricStyleSalesInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IN0092");
  }
  static FabricStyleSalesInquirySendMailReport_IsAccessible() {
    return this.isAccessible("IN0093");
  }
  //endRegion
  //#region	SalesOrder Status Inquiry
  static SalesOrderStatusInquiry_IsAccessible() {
    return this.isAccessible("IN0120");
  }
  static SalesOrderStatusInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IN0121");
  }
  static SalesOrderStatusInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IN0122");
  }
  static SalesOrderStatusInquirySendMailReport_IsAccessible() {
    return this.isAccessible("IN0123");
  }
  //#endregion
  //#region Sales Analysis Inquiry
  static SalesAnalysisInquiry_IsAccessible() {
    return this.isAccessible("INSA00");
  }
  static SalesAnalysisInquiryPDFReport_IsAccessible() {
    return this.isAccessible("INSA01");
  }
  static SalesAnalysisInquiryExcelReport_IsAccessible() {
    return this.isAccessible("INSA02");
  }
  static SalesAnalysisInquirySendMailReport_IsAccessible() {
    return this.isAccessible("INSA03");
  }
  //#endRegion
  //#region Customer Sales Analysis  Inquiry
  static CustomerSalesAnalysisInquiry_IsAccessible() {
    return this.isAccessible("ICSA00");
  }
  static CustomerSalesAnalysisInquiryPDFReport_IsAccessible() {
    return this.isAccessible("ICSA01");
  }
  static CustomerSalesAnalysisInquiryExcelReport_IsAccessible() {
    return this.isAccessible("ICSA02");
  }
  static CustomerSalesAnalysisInquirySendMailReport_IsAccessible() {
    return this.isAccessible("ICSA03");
  }
  //#endRegion
  //#region FiscalYear Booking Inquiry
  static FiscalYearBookingInquiry_IsAccessible() {
    return this.isAccessible("IFYB00");
  }
  static FiscalYearBookingInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IFYB01");
  }
  static FiscalYearBookingInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IFYB02");
  }
  static FiscalYearBookingInquirySendMailReport_IsAccessible() {
    return this.isAccessible("IFYB03");
  }
  //#endRegion
  //#region  FabricStyle yearly Sales Analysis inquiry
  static FabricStyleYearlySalesAnalysisInquiry_IsAccessible() {
    return this.isAccessible("IN0390");
  }
  static FabricStyleYearlySalesAnalysisInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IN0391");
  }
  static FabricStyleYearlySalesAnalysisInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IN0392");
  }
  static FabricStyleYearlySalesAnalysisInquirySendMailReport_IsAccessible() {
    return this.isAccessible("IN0393");
  }
  //#endregion
  //#region  yearly Sales Analysis inquiry
  static YearlySalesAnalysisInquiry_IsAccessible() {
    return this.isAccessible("IN0380");
  }
  static YearlySalesAnalysisInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IN0381");
  }
  static YearlySalesAnalysisInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IN0382");
  }
  static YearlySalesAnalysisInquirySendMailReport_IsAccessible() {
    return this.isAccessible("IN0383");
  }
  //#endregion
  //#endRegion
  //#region InBound
  //#region Inbound OpenOrder Not Received Details
  static InboundOpenOrderNotReceivedDetailsInquirylsInquiry_IsAccessible() {
    return this.isAccessible("IBOONR0");
  }
  static InboundOpenOrderNotReceivedDetailsInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IBOONR1");
  }
  static InboundOpenOrderNotReceivedDetailsInquiryInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IBOONR2");
  }
  //#endregion
  //#region Inbound Receipt Not Invoiced
  static InboundReceiptNotInvoicedInquiry_IsAccessible() {
    return this.isAccessible("IBRNI0");
  }
  static InboundReceiptNotInvoicedPDFReport_IsAccessible() {
    return this.isAccessible("IBRNI1");
  }
  static InboundReceiptNotInvoicedExcelReport_IsAccessible() {
    return this.isAccessible("IBRNI2");
  }
  //#endregion
  //#endregion
  //#region Purchase
  //#region PurchaseOrder UnApproved Details inquiry
  static PurchaseOrderUnApprovedDetails_IsAccessible() {
    return this.isAccessible("INPOUA00");
  }
  static PurchaseOrderUnApprovedDetailsPDFReport_IsAccessible() {
    return this.isAccessible("INPOUA01");
  }
  static PurchaseOrderUnApprovedDetailsExcelReport_IsAccessible() {
    return this.isAccessible("INPOUA02");
  }
  static PurchaseOrderUnApprovedDetailsSendMailReport_IsAccessible() {
    return this.isAccessible("INPOUA03");
  }
  //#endregion
  // #region FabricStyle Purchase History Inquiry
  static FabricStylePurchaseHistoryInquiry_IsAccessible() {
    return this.isAccessible("INFPOH00");
  }
  static FabricStylePurchaseHistoryInquiryPDFReport_IsAccessible() {
    return this.isAccessible("INFPOH01");
  }
  static FabricStylePurchaseHistoryInquiryExcelReport_IsAccessible() {
    return this.isAccessible("INFPOH02");
  }
  static FabricStylePurchaseHistoryInquirySendMailReport_IsAccessible() {
    return this.isAccessible("INFPOH03");
  }
  //#endregion
  // #region PurchaseOrder InTransit Infos inquiry
  static PurchaseOrderInTransitInfosInquiry_IsAccessible() {
    return this.isAccessible("INPINT00");
  }
  static PurchaseOrderInTransitInfosInquiryPDFReport_IsAccessible() {
    return this.isAccessible("INPINT01");
  }
  static PurchaseOrderInTransitInfosInquiryExcelReport_IsAccessible() {
    return this.isAccessible("INPINT02");
  }
  static PurchaseOrderInTransitInfosInquirySendMailReport_IsAccessible() {
    return this.isAccessible("INPINT03");
  }
  //#endregion
  //#region PurchaseOrderReceiptInquiry
  static PurchaseorderReceiptInquiry_IsAccessible() {
    return this.isAccessible("INPR00");
  }
  static PurchaseorderReceiptInquiryPDFReport_IsAccessible() {
    return this.isAccessible("INPR01");
  }
  static PurchaseorderReceiptInquiryExcelReport_IsAccessible() {
    return this.isAccessible("INPR02");
  }
  static PurchaseorderReceiptInquiryMailReport_IsAccessible() {
    return this.isAccessible("INPR03");
  }
  // #endregion
  //#region Receipt Roll Bin Summary inquiry
  static ReceiptRollBinSummaryInquiry_IsAccessible() {
    return this.isAccessible("INRLBN00");
  }
  static ReceiptRollBinSummaryInquiryPDFReport_IsAccessible() {
    return this.isAccessible("INRLBN01");
  }
  static ReceiptRollBinSummaryInquiryExcelReport_IsAccessible() {
    return this.isAccessible("INRLBN02");
  }
  static ReceiptRollBinSummaryInquiryMailReport_IsAccessible() {
    return this.isAccessible("INRLBN03");
  }
  // #endregion
  //#region Late PurchaseOrder Details Inquiry
  static LatePurchaseOrderDetailsInquiry_IsAccessible() {
    return this.isAccessible("INLP00");
  }
  static LatePurchaseOrderDetailsInquiryPDFReport_IsAccessible() {
    return this.isAccessible("INLP01");
  }
  static LatePurchaseOrderDetailsInquiryExcelReport_IsAccessible() {
    return this.isAccessible("INLP02");
  }
  static LatePurchaseOrderDetailsInquiryMailReport_IsAccessible() {
    return this.isAccessible("INLP03");
  }
  //#endregion
  //#region FabricStyles Received Details Inquiry
  static FabricStylesReceivedDetailsInquiry_IsAccessible() {
    return this.isAccessible("INRV00");
  }
  static FabricStylesReceivedDetailsInquiryPDFReport_IsAccessible() {
    return this.isAccessible("INRV01");
  }
  static FabricStylesReceivedDetailsInquiryExcelReport_IsAccessible() {
    return this.isAccessible("INRV02");
  }
  static FabricStylesReceivedDetailsInquiryMailReport_IsAccessible() {
    return this.isAccessible("INRV03");
  }
  //#endregion
  //#endRegion
  //#region Statistics
  //#region Customer Statitics inquiry
  static CustomerStatiticsInquiry_IsAccessible() {
    return this.isAccessible("IN0240");
  }
  static CustomerStatiticsInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IN0241");
  }
  static CustomerStatiticsInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IN0242");
  }
  static CustomerStatiticsInquirySendMailReport_IsAccessible() {
    return this.isAccessible("IN0243");
  }
  //#endregion
  //#region Vendor Statitics inquiry
  static VendorStatiticsInquiry_IsAccessible() {
    return this.isAccessible("IN0250");
  }
  static VendorStatiticsInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IN0251");
  }
  static VendorStatiticsInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IN0252");
  }
  static VendorStatiticsInquirySendMailReport_IsAccessible() {
    return this.isAccessible("IN0253");
  }
  //#endregion
  //#endRegion
  //#region Accounts
  //# Customer Transaction Inquiry
  static CustomerTransactionInquiry_IsAccessible() {
    return this.isAccessible("IN0190");
  }
  static CustomerTransactionInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IN0191");
  }
  static CustomerTransactionInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IN0192");
  }
  static CustomerTransactionInquiryMailReport_IsAccessible() {
    return this.isAccessible("IN0193");
  }
  //# endRegion
  //#region Customer Balance inquiry
  static CustomerBalanceInquiry_IsAccessible() {
    return this.isAccessible("IN0230");
  }
  static CustomerBalanceInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IN0231");
  }
  static CustomerBalanceInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IN0232");
  }
  static CustomerBalanceInquirySendMailReport_IsAccessible() {
    return this.isAccessible("IN0233");
  }
  // #endregion
  //#region Customer Statement Inquiry
  static CustomerStatementInquiry_IsAccessible() {
    return this.isAccessible("INCS00");
  }
  static CustomerStatementInquiryPDFReport_IsAccessible() {
    return this.isAccessible("INCS02");
  }
  static CustomerStatementInquiryExcelReport_IsAccessible() {
    return this.isAccessible("INCS02");
  }
  static CustomerStatementInquiryMail_IsAccessible() {
    return this.isAccessible("INCS03");
  }
  //#endregion
  //#region CreditMemo Details Inquiry
  static CreditMemoDetailsInquiry_IsAccessible() {
    return this.isAccessible("ICMD00");
  }
  static CreditMemoDetailsInquiryPDFReport_IsAccessible() {
    return this.isAccessible("ICMD01");
  }
  static CreditMemoDetailsInquiryExcelReport_IsAccessible() {
    return this.isAccessible("ICMD02");
  }
  static CreditMemoDetailsInquiryMailReport_IsAccessible() {
    return this.isAccessible("ICMD03");
  }
  //#endregion
  // #region BankAccoutBalanceHistory Inquiry
  static BankAccountBalanceHistoryTrackInquiry_IsAccessible() {
    return this.isAccessible("INBKB00");
  }
  static BankAccountBalanceHistoryTrackInquiryPDFReport_IsAccessible() {
    return this.isAccessible("INBKB01");
  }
  static BankAccountBalanceHistoryTrackInquiryExcelReport_IsAccessible() {
    return this.isAccessible("INBKB02");
  }
  //#endregion
  //#region Past Due Invoices With CC Payment inquiry
  static PastDueInvoicesWithCCPaymentInquiry_IsAccessible() {
    return this.isAccessible("IN0180");
  }
  static PastDueInvoicesWithCCPaymentInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IN0181");
  }
  static PastDueInvoicesWithCCPaymentInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IN0182");
  }
  static PastDueInvoicesWithCCPaymentInquirySendMailReport_IsAccessible() {
    return this.isAccessible("IN0183");
  }
  //#endregion
  //#region Customer Current inquiry
  static CustomerCurrentAgingInquiry_IsAccessible() {
    return this.isAccessible("IN0210");
  }
  static CustomerCurrentAgingInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IN0211");
  }
  static CustomerCurrentAgingInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IN0212");
  }
  static CustomerCurrentAgingInquirySendMailReport_IsAccessible() {
    return this.isAccessible("IN0213");
  }
  //#endregion
  //#region All Customer Online Aging inquiry
  static AllCustomerOnlineAgingInquiry_IsAccessible() {
    return this.isAccessible("IN0200");
  }
  static AllCustomerOnlineAgingInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IN0201");
  }
  static AllCustomerOnlineAgingInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IN0202");
  }
  static AllCustomerOnlineAgingInquirySendMailReport_IsAccessible() {
    return this.isAccessible("IN0203");
  }
  //#endregion
  //# SalesPerson Inquiry
  static SalesPersonPaymentAgingInquiry_IsAccessible() {
    return this.isAccessible("IN0220");
  }
  static SalesPersonPaymentAgingInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IN0221");
  }
  static SalesPersonPaymentAgingInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IN0222");
  }
  static SalesPersonPaymentAgingInquiryMailReport_IsAccessible() {
    return this.isAccessible("IN0223");
  }
  //# endRegion
  //#endRegion
  //#region Payment history
  // #region Posted AR Day Register inquiry
  static PostedARDayRegisterInquiry_IsAccessible() {
    return this.isAccessible("IN0260");
  }
  static PostedARDayRegisterInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IN0261");
  }
  static PostedARDayRegisterInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IN0262");
  }
  static PostedARDayRegisterInquirySendMailReport_IsAccessible() {
    return this.isAccessible("IN0263");
  }
  // #endregion
  // #region Posted and Bounced Check Details Inquiry
  static PostedandBouncedCheckInquiry_IsAccessible() {
    return this.isAccessible("PBCI00");
  }
  static PostedandBouncedCheckInquiryPDFReport_IsAccessible() {
    return this.isAccessible("PBCI01");
  }
  static PostedandBouncedCheckInquiryExcelReport_IsAccessible() {
    return this.isAccessible("PBCI02");
  }
  static PostedandBouncedCheckInquirySendMailReport_IsAccessible() {
    return this.isAccessible("PBCI03");
  }
  //#endregion
  // #region Posted AR CashPayment Register inquiry
  static PostedARCashPaymentRegisterInquiry_IsAccessible() {
    return this.isAccessible("IN0280");
  }
  static PostedARCashPaymentRegisterInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IN0281");
  }
  static PostedARCashPaymentRegisterInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IN0282");
  }
  static PostedARCashPaymentRegisterInquirySendMailReport_IsAccessible() {
    return this.isAccessible("IN0283");
  }
  //#endregion
  //#region Posted AR CardPayment Register inquiry
  static PostedARCardPaymentRegisterInquiry_IsAccessible() {
    return this.isAccessible("IN0290");
  }
  static PostedARCardPaymentRegisterInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IN0291");
  }
  static PostedARCardPaymentRegisterInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IN0292");
  }
  static PostedARCardPaymentRegisterInquirySendMailReport_IsAccessible() {
    return this.isAccessible("IN0293");
  }
  //#endregion
  //#region Posted AR WirePayment Register inquiry
  static PostedARWirePaymentRegisterInquiry_IsAccessible() {
    return this.isAccessible("IN0300");
  }
  static PostedARWirePaymentRegisterInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IN0301");
  }
  static PostedARWirePaymentRegisterInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IN0302");
  }
  static PostedARWirePaymentRegisterInquirySendMailReport_IsAccessible() {
    return this.isAccessible("IN0303");
  }
  //#endregion
  //#region Posted AR CheckPayment Register inquiry
  static PostedARCheckPaymentRegisterInquiryIsAccessible() {
    return this.isAccessible("IN0270");
  }
  static PostedARCheckPaymentRegisterInquiryPDFReportIsAccessible() {
    return this.isAccessible("IN0271");
  }
  static PostedARCheckPaymentRegisterInquiryExcelReportIsAccessible() {
    return this.isAccessible("IN0272");
  }
  static PostedARCheckPaymentRegisterInquirySendMailReportIsAccessible() {
    return this.isAccessible("IN0273");
  }
  //#endregion
  //#region Check Payment History inquiry
  static CheckPaymentHistoryInquiry_IsAccessible() {
    return this.isAccessible("IN0320");
  }
  static CheckPaymentHistoryInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IN0321");
  }
  static CheckPaymentHistoryInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IN0322");
  }
  static CheckPaymentHistoryInquirySendMailReport_IsAccessible() {
    return this.isAccessible("IN0323");
  }
  //#endregion
  //#region CardPayment Inquiry
  static CardPaymentHistoryInquiry_IsAccessible() {
    return this.isAccessible("IN0330");
  }
  static CardPaymentHistoryInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IN0331");
  }
  static CardPaymentHistoryInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IN0332");
  }
  static CardPaymentHistoryInquiryMailReport_IsAccessible() {
    return this.isAccessible("IN0333");
  }
  //#endRegion
  //#Posted AR ACH Payment
  static PostedARACHPaymentRegisterInquiry_IsAccessible() {
    return this.isAccessible("INPACH00");
  }
  static PostedARACHPaymentRegisterInquiryPDFReport_IsAccessible() {
    return this.isAccessible("INPACH01");
  }
  static PostedARACHPaymentRegisterInquiryExcelReport_IsAccessible() {
    return this.isAccessible("INPACH02");
  }
  static PostedARACHPaymentRegisterInquiryMailReport_IsAccessible() {
    return this.isAccessible("INPACH03");
  }
  //#endRegion

  //#region ACH Payment Inquiry
  static ACHPaymentHistoryInquiry_IsAccessible() {
    return this.isAccessible("INACH00");
  }
  static ACHPaymentHistoryInquiryPDFReport_IsAccessible() {
    return this.isAccessible("INACH01");
  }
  static ACHPaymentHistoryInquiryExcelReport_IsAccessible() {
    return this.isAccessible("INACH02");
  }
  static ACHPaymentHistoryInquiryMailReport_IsAccessible() {
    return this.isAccessible("INACH03");
  }
  //#endRegion
  //#WirePayment Inquiry
  static WirePaymentHistoryInquiry_IsAccessible() {
    return this.isAccessible("IN0350");
  }
  static WirePaymentHistoryInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IN0351");
  }
  static WirePaymentHistoryInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IN0352");
  }
  static WirePaymentHistoryInquiryMailReport_IsAccessible() {
    return this.isAccessible("IN0353");
  }
  //#endRegion

  //#region Bounced Check Inquiry
  static BouncedCheckInquiry_IsAccessible() {
    return this.isAccessible("BCI00");
  }
  static BouncedCheckInquiryPDFReport_IsAccessible() {
    return this.isAccessible("BCI01");
  }
  static BouncedCheckInquiryExcelReport_IsAccessible() {
    return this.isAccessible("BCI02");
  }
  static BouncedCheckInquiryMailReport_IsAccessible() {
    return this.isAccessible("BCI03");
  }
  //#endRegion
  //#region UnPostedARListInquiry
  static UnPostedARListInquiry_IsAccessible() {
    return this.isAccessible("IN0310");
  }
  static UnPostedARListInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IN0311");
  }
  static UnPostedARListInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IN0312");
  }
  static UnPostedARListInquiryMailReport_IsAccessible() {
    return this.isAccessible("IN0313");
  }
  //#endRegion
  //#region CreditMemoPaymentHistoryInquiry
  static CreditMemoPaymentHistoryInquiry_IsAccessible() {
    return this.isAccessible("IN0340");
  }
  static CreditMemoPaymentHistoryInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IN0341");
  }
  static CreditMemoPaymentHistoryInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IN0342");
  }
  static CreditMemoPaymentHistoryInquiryMailReport_IsAccessible() {
    return this.isAccessible("IN0343");
  }
  //#endRegion
  //#region	Cash Payement Activities Inquiry
  static CashPaymentActivityInquiry_IsAccessible() {
    return this.isAccessible("INC060");
  }
  static CashPaymentActivityInquiryPDFReport_IsAccessible() {
    return this.isAccessible("INC061");
  }
  static CashPaymentActivityInquiryExcelReport_IsAccessible() {
    return this.isAccessible("INC062");
  }
  static CashPaymentActivityInquiryMail_IsAccessible() {
    return this.isAccessible("INC063");
  }
  static CashPaymentActivityInquiryPrint_IsAccessible() {
    return this.isAccessible("INC064");
  }
  //#endregion
  //#region	Post Dated Check Detail Inquiry
  static PostDatedChecksInquiry_IsAccessible() {
    return this.isAccessible("INC070");
  }
  static PostDatedChecksInquiryPDFReport_IsAccessible() {
    return this.isAccessible("INC071");
  }
  static PostDatedChecksInquiryExcelReport_IsAccessible() {
    return this.isAccessible("INC072");
  }
  static PostDatedChecksInquiryMail_IsAccessible() {
    return this.isAccessible("INC073");
  }
  static PostDatedChecksInquiryPrint_IsAccessible() {
    return this.isAccessible("INC074");
  }
  //#endregion
  //#endRegion
  //#endRegion
  //#region Security
  //#region User
  static UserRoleMaintenance_IsAccessible() {
    return this.isAccessible("MUR00");
  }
  static UserRoleMaintenanceCreate_IsAccessible() {
    return this.isAccessible("MUR01");
  }
  static UserRoleMaintenanceEdit_IsAccessible() {
    return this.isAccessible("MUR02");
  }
  static UserRoleMaintenanceView_IsAccessible() {
    return this.isAccessible("MUR03");
  }
  //#endregion
  //#region Role
  static RoleMaintenance_IsAccessible() {
    return this.isAccessible("MRL00");
  }
  static RoleMaintenanceCreate_IsAccessible() {
    return this.isAccessible("MRL01");
  }
  static RoleMaintenanceEdit_IsAccessible() {
    return this.isAccessible("MRL02");
  }
  static RoleMaintenanceView_IsAccessible() {
    return this.isAccessible("MRL03");
  }
  //#endregion
  //#endRegion
  //#region System
  //# ReleaseLock
  static EntityLockDisplay_IsAccessible() {
    return this.isAccessible("SLK01");
  }
  static EntityLockRelease_IsAccessible() {
    return this.isAccessible("SLK02");
  }

  /***** CPM *****/
  static CriticalPathManagementTaskMaintainance_IsAccessible() {
    return this.isAccessible("CPT00");
  }

  static CriticalPathManagementTaskCreation_IsAccessible() {
    return this.isAccessible("CPT01");
  }

  static CriticalPathManagementTaskUpdation_IsAccessible() {
    return this.isAccessible("CPT02");
  }

  static CriticalPathManagementTaskView_IsAccessible() {
    return this.isAccessible("CPT03");
  }

  /***** CPM Template*****/
  static CriticalPathManagementTemplateMaintainance_IsAccessible() {
    return this.isAccessible("CTP00");
  }

  static CriticalPathManagementTemplateCreation_IsAccessible() {
    return this.isAccessible("CTP01");
  }

  static CriticalPathManagementTemplateUpdation_IsAccessible() {
    return this.isAccessible("CTP02");
  }

  static CriticalPathManagementTemplateView_IsAccessible() {
    return this.isAccessible("CTP03");
  }

  /***** Critical path Management aka CPM *****/

  static CriticalPathManagementMaintainance_IsAccessible() {
    return this.isAccessible("CPM00");
  }

  static CriticalPathManagementCreation_IsAccessible() {
    return this.isAccessible("CPM01");
  }

  static CriticalPathManagementUpdation_IsAccessible() {
    return this.isAccessible("CPM02");
  }

  static CriticalPathManagementView_IsAccessible() {
    return this.isAccessible("CPM03");
  }

  static CriticalPathManagementApprove_IsAccessible() {
    return this.isAccessible("CPM04");
  }

  static CriticalPathManagementUnApprove_IsAccessible() {
    return this.isAccessible("CPM05");
  }

  static CriticalPathManagementConfirm_IsAccessible() {
    return this.isAccessible("CPM06");
  }

  static CriticalPathManagementClose_IsAccessible() {
    return this.isAccessible("CPM07");
  }

  static CriticalPathManagementCancel_IsAccessible() {
    return this.isAccessible("CPM08");
  }

  static CpmEntryModuleMaintenancePDFReport_IsAccessible() {
    return this.isAccessible("CPM09");
  }

  static CpmEntryModuleMaintenanceExcelReport_IsAccessible() {
    return this.isAccessible("CPM10");
  }

  static CpmEntryModuleMaintenanceSendMailReportCancel_IsAccessible() {
    return this.isAccessible("CPM11");
  }

  //#region	Sales Service Detail Inquiry
  static SalesServiceDetailsInquiry_IsAccessible() {
    return this.isAccessible("SSD00");
  }
  static SalesServiceDetailsInquiryPDFReport_IsAccessible() {
    return this.isAccessible("SSD01");
  }
  static SalesServiceDetailsInquiryExcelReport_IsAccessible() {
    return this.isAccessible("SSD02");
  }
  static SalesServiceDetailsInquiryMail_IsAccessible() {
    return this.isAccessible("SSD03");
  }
  //#endregion

  //#region	Sales Commodity Detail Inquiry
  static SalesCommodityDetailsInquiry_IsAccessible() {
    return this.isAccessible("SCD00");
  }
  static SalesCommodityDetailsInquiryPDFReport_IsAccessible() {
    return this.isAccessible("SCD01");
  }
  static SalesCommodityDetailsInquiryExcelReport_IsAccessible() {
    return this.isAccessible("SCD02");
  }
  static SalesCommodityDetailsInquiryMail_IsAccessible() {
    return this.isAccessible("SCD03");
  }
  //#endregion

  //#region	Sales Price Detail Inquiry
  static salesPriceInquiry_IsAccessible() {
    return this.isAccessible("SPD00");
  }
  static salesPriceInquiryPDFReport_IsAccessible() {
    return this.isAccessible("SPD01");
  }
  static salesPriceInquiryExcelReport_IsAccessible() {
    return this.isAccessible("SPD02");
  }
  static salesPriceInquiryMail_IsAccessible() {
    return this.isAccessible("SPD03");
  }
  //#endregion

  //#region	Rolling Inventory Detail Inquiry
  static RollingInventoryReportDetailsInquiry_IsAccessible() {
    return this.isAccessible("RIRD00");
  }
  static RollingInventoryReportDetailsInquiryPDFReport_IsAccessible() {
    return this.isAccessible("RIRD01");
  }
  static RollingInventoryReportDetailsInquiryExcelReport_IsAccessible() {
    return this.isAccessible("RIRD02");
  }
  static RollingInventoryReportDetailsInquiryMail_IsAccessible() {
    return this.isAccessible("RIRD03");
  }
  //#endregion

  //#region	CPM Report Inquiry
  static cpmReportInquiry_IsAccessible() {
    return this.isAccessible("CPMRD00");
  }
  static cpmReportInquiryPDFReport_IsAccessible() {
    return this.isAccessible("CPMRD01");
  }
  static cpmReportInquiryExcelReport_IsAccessible() {
    return this.isAccessible("CPMRD02");
  }
  static cpmReportInquiryMail_IsAccessible() {
    return this.isAccessible("CPMRD03");
  }
  //#endregion

  //#region	SalesAndPurchaseDetails Inquiry
  static salesAndPurchaseDetailsInquiry_IsAccessible() {
    return this.isAccessible("SAPD00");
  }
  static salesAndPurchaseDetailsInquiryPDFReport_IsAccessible() {
    return this.isAccessible("SAPD01");
  }
  static salesAndPurchaseDetailsInquiryExcelReport_IsAccessible() {
    return this.isAccessible("SAPD02");
  }
  static salesAndPurchaseDetailsInquiryMail_IsAccessible() {
    return this.isAccessible("SAPD03");
  }
  //#endregion

  //#region	DailyInventoryTrack Inquiry
  static DailyInventoryTrackInquiry_IsAccessible() {
    return this.isAccessible("DITH00");
  }
  static DailyInventoryTrackInquiryPDFReport_IsAccessible() {
    return this.isAccessible("DITH00");
  }
  static DailyInventoryTrackInquiryExcelReport_IsAccessible() {
    return this.isAccessible("DITH00");
  }
  static DailyInventoryTrackInquiryMail_IsAccessible() {
    return this.isAccessible("DITH00");
  }
  //#endregion

  //#region	DailyInventoryProcessTrack Inquiry
  static DailyInventoryProcessTrackInquiry_IsAccessible() {
    return this.isAccessible("DIPTD00");
  }
  static DailyInventoryProcessTrackInquiryPDFReport_IsAccessible() {
    return this.isAccessible("DIPTD01");
  }
  static DailyInventoryProcessTrackInquiryExcelReport_IsAccessible() {
    return this.isAccessible("DIPTD02");
  }
  static DailyInventoryProcessTrackInquiryMail_IsAccessible() {
    return this.isAccessible("DIPTD03");
  }
  //#endregion

  //#region InvoicePrintoutTyp Attribute
  static InvoicePrintoutType_IsAccessible() {
    return this.isAccessible("INVPOT00");
  }
  static InvoicePrintoutTypeCreate_IsAccessible() {
    return this.isAccessible("INVPOT01");
  }
  static InvoicePrintoutTypeEdit_IsAccessible() {
    return this.isAccessible("INVPOT02");
  }
  static InvoicePrintoutTypeView_IsAccessible() {
    return this.isAccessible("INVPOT03");
  }
  static InvoicePrintoutTypeDelete_IsAccessible() {
    return this.isAccessible("INVPOT04");
  }

  //#region	LotBasedInventoryInOutInquiry
  static LotBasedInventoryInOutInquiry_IsAccessible() {
    return this.isAccessible("LBIIOI00");
  }
  static LotBasedInventoryInOutInquiryPDFReport_IsAccessible() {
    return this.isAccessible("LBIIOI01");
  }
  static LotBasedInventoryInOutInquiryExcelReport_IsAccessible() {
    return this.isAccessible("LBIIOI02");
  }
  static LotBasedInventoryInOutInquiryMail_IsAccessible() {
    return this.isAccessible("LBIIOI03");
  }
  //#endregion

  //# endRegion
  //#endRegion
  //#region Test
  static TestTrue_IsAccessible() {
    return true;
  }
  static TestFalse_IsAccessible() {
    return this.isAccessible("SLvbdfbdfK02");
  }
  //#endRegion
  //#endregion

  // static DebitMemoMaintenanceModule_IsAccessible() {
  //   return true;
  // }

  static DebitMemoMaintenance_IsAccessible() {
    return this.isAccessible("DM00");
    // return true;
  }
  static DebitMemoMaintenanceCreate_IsAccessible() {
    return this.isAccessible("DM01");
    //return true;
  }
  static DebitMemoMaintenanceUpdate_IsAccessible() {
    return this.isAccessible("DM02");
    // return true;
  }
  static DebitMemoMaintenanceView_IsAccessible() {
    return this.isAccessible("DM03");
    //  return true;
  }
  static DebitMemoMaintenanceApproval_IsAccessible() {
    return this.isAccessible("DM04");
    //return true;
  }
  static DebitMemoMaintenanceUnApproval_IsAccessible() {
    return this.isAccessible("DM05");
    // return true;
  }
  static DebitMemoMaintenanceCancel_IsAccessible() {
    return this.isAccessible("DM06");
    //return true;
  }
  static DebitMemoMaintenancePDF_IsAccessible() {
    return this.isAccessible("DM07");
  }
  static DebitMemoMaintenanceExcel_IsAccessible() {
    return this.isAccessible("DM08");
  }
  static DebitMemoMaintenanceMail_IsAccessible() {
    return this.isAccessible("DM09");
  }
  static DebitMemoMaintenanceAdjust_IsAccessible() {
    return this.isAccessible("DM10");
  }
  static DebitMemoMaintenanceVendorRefund_IsAccessible() {
    return this.isAccessible("DM11");
  }
  static DebitMemoMaintenanceApproveandPrint_IsAccessible() {
    return this.isAccessible("DM12");
  }
  static DebitMemoMaintenancePrintreport_IsAccessible() {
    return this.isAccessible("DM13");
  }
  static DebitMemoMaintenanceMailReportEdit_IsAccessible() {
    return this.isAccessible("DM14");
  }
  static DebitMemoMaintenanceApplyToInvoice_IsAccessible() {
    return this.isAccessible("DM15");
  }

  //#region	InvoiceSCAdjustmentReason
  static InvoiceSCAdjustmentReason_IsAccessible() {
    return this.isAccessible("M6120");
  }
  static InvoiceSCAdjustmentReasonCreate_IsAccessible() {
    return this.isAccessible("M6121");
  }
  static InvoiceSCAdjustmentReasonEdit_IsAccessible() {
    return this.isAccessible("M6122");
  }
  static InvoiceSCAdjustmentReasonView_IsAccessible() {
    return this.isAccessible("M6123");
  }
  static InvoiceSCAdjustmentReasonDelete_IsAccessible() {
    return this.isAccessible("M6124");
  }
  //#endregion

  //#region	CustomerDistributionCenter
  static CustomerDistributionCenter_IsAccessible() {
    return this.isAccessible("M6240");
  }
  static CustomerDistributionCenterCreate_IsAccessible() {
    return this.isAccessible("M6241");
  }
  static CustomerDistributionCenterEdit_IsAccessible() {
    return this.isAccessible("M6242");
  }
  static CustomerDistributionCenterView_IsAccessible() {
    return this.isAccessible("M6243");
  }
  static CustomerDistributionCenterDelete_IsAccessible() {
    return this.isAccessible("M6244");
  }
  //#endregion

  //#region	CustomerBillto
  static CustomerBillTo_IsAccessible() {
    return this.isAccessible("MCS10");
  }
  static CustomerBillToCreate_IsAccessible() {
    return this.isAccessible("MCS11");
  }
  static CustomerBillToEdit_IsAccessible() {
    return this.isAccessible("MCS12");
  }
  static CustomerBillToView_IsAccessible() {
    return this.isAccessible("MCS13");
  }
  //#endregion

  //#region	CustomerShipTo
  static CustomerShipTo_IsAccessible() {
    return this.isAccessible("MCS20");
  }
  static CustomerShipToCreate_IsAccessible() {
    return this.isAccessible("MCS21");
  }
  static CustomerShipToEdit_IsAccessible() {
    return this.isAccessible("MCS22");
  }
  static CustomerShipToView_IsAccessible() {
    return this.isAccessible("MCS23");
  }
  static CustomerShipToDelete_IsAccessible() {
    return this.isAccessible("MCS24");
  }
  //#endregion

  //#region	CustomerSalesCommission
  static CustomerSalesCommission_IsAccessible() {
    return this.isAccessible("MCS40");
  }
  static CustomerSalesCommissionCreate_IsAccessible() {
    return this.isAccessible("MCS41");
  }
  static CustomerSalesCommissionEdit_IsAccessible() {
    return this.isAccessible("MCS42");
  }
  static CustomerSalesCommissionView_IsAccessible() {
    return this.isAccessible("MCS43");
  }
  static CustomerSalesCommissionDelete_IsAccessible() {
    return this.isAccessible("MCS44");
  }
  //#endregion

  //#region	CustomerCreditCard
  static CustomerCreditCard_IsAccessible() {
    return this.isAccessible("MCS60");
  }
  static CustomerCreditCardCreate_IsAccessible() {
    return this.isAccessible("MCS61");
  }
  static CustomerCreditCardEdit_IsAccessible() {
    return this.isAccessible("MCS62");
  }
  static CustomerCreditCardView_IsAccessible() {
    return this.isAccessible("MCS63");
  }
  static CustomerCreditCardDelete_IsAccessible() {
    return this.isAccessible("MCS64");
  }
  //#endregion

  //#region	VendorInvoiceMisChargeReason
  static VendorInvoiceMisChargeReason_IsAccessible() {
    return this.isAccessible("MFMVCR00");
  }
  static VendorInvoiceMisChargeReasonCreate_IsAccessible() {
    return this.isAccessible("MFMVCR01");
  }
  static VendorInvoiceMisChargeReasonEdit_IsAccessible() {
    return this.isAccessible("MFMVCR02");
  }
  static VendorInvoiceMisChargeReasonView_IsAccessible() {
    return this.isAccessible("MFMVCR03");
  }
  static VendorInvoiceMisChargeReasonDelete_IsAccessible() {
    return this.isAccessible("MFMVCR04");
  }
  //#endregion

  //#region	ARType
  static ARType_IsAccessible() {
    return this.isAccessible("M1180");
  }
  static ARTypeCreate_IsAccessible() {
    return this.isAccessible("M1181");
  }
  static ARTypeEdit_IsAccessible() {
    return this.isAccessible("M1182");
  }
  static ARTypeView_IsAccessible() {
    return this.isAccessible("M1183");
  }
  static ARTypeDelete_IsAccessible() {
    return this.isAccessible("M1184");
  }
  //#endregion

  //#region	FinancialType
  static FinancialType_IsAccessible() {
    return this.isAccessible("M1080");
  }
  static FinancialTypeCreate_IsAccessible() {
    return this.isAccessible("M1081");
  }
  static FinancialTypeEdit_IsAccessible() {
    return this.isAccessible("M1082");
  }
  static FinancialTypeView_IsAccessible() {
    return this.isAccessible("M1083");
  }
  static FinancialTypeDelete_IsAccessible() {
    return this.isAccessible("M1084");
  }
  //#endregion

  //#region	WareHouse
  static WareHouse_IsAccessible() {
    return this.isAccessible("M1100");
  }
  static WareHouseCreate_IsAccessible() {
    return this.isAccessible("M1101");
  }
  static WareHouseEdit_IsAccessible() {
    return this.isAccessible("M1102");
  }
  static WareHouseView_IsAccessible() {
    return this.isAccessible("M1103");
  }
  static WareHouseDelete_IsAccessible() {
    return this.isAccessible("M1104");
  }
  //#endregion

  //#region	CreditMemoReason
  static CreditMemoReason_IsAccessible() {
    return this.isAccessible("M6230");
  }
  static CreditMemoReasonCreate_IsAccessible() {
    return this.isAccessible("M6231");
  }
  static CreditMemoReasonEdit_IsAccessible() {
    return this.isAccessible("M6232");
  }
  static CreditMemoReasonView_IsAccessible() {
    return this.isAccessible("M6233");
  }
  static CreditMemoReasonDelete_IsAccessible() {
    return this.isAccessible("M6234");
  }
  //#endregion

  //#region	StageType
  static StageType_IsAccessible() {
    return this.isAccessible("M6270");
  }
  static StageTypeCreate_IsAccessible() {
    return this.isAccessible("M6271");
  }
  static StageTypeEdit_IsAccessible() {
    return this.isAccessible("M6272");
  }
  static StageTypeView_IsAccessible() {
    return this.isAccessible("M6273");
  }
  static StageTypeDelete_IsAccessible() {
    return this.isAccessible("M6274");
  }
  //#endregion

  //#region	GroupSalesOrderMaintenance
  static GroupSalesOrderMaintenance_IsAccessible() {
    return this.isAccessible("GSL00");
  }
  static GroupSalesOrderMaintenanceCreate_IsAccessible() {
    return this.isAccessible("GSL01");
  }
  static GroupSalesOrderMaintenanceEdit_IsAccessible() {
    return this.isAccessible("GSL02");
  }
  static GroupSalesOrderMaintenanceView_IsAccessible() {
    return this.isAccessible("GSL03");
  }
  static GroupSalesOrderMaintenanceApprove_IsAccessible() {
    return this.isAccessible("GSL04");
  }
  static GroupSalesOrderMaintenanceUnApprove_IsAccessible() {
    return this.isAccessible("GSL05");
  }
  //#endregion

  //#region	PackingList
  static PackingList_IsAccessible() {
    return this.isAccessible("PL00");
  }
  static PackingListCreate_IsAccessible() {
    return this.isAccessible("PL01");
  }
  static PackingListEdit_IsAccessible() {
    return this.isAccessible("PL02");
  }
  static PackingListView_IsAccessible() {
    return this.isAccessible("PL03");
  }
  static PackingListApprove_IsAccessible() {
    return this.isAccessible("PL04");
  }
  static PackingListCancel_IsAccessible() {
    return this.isAccessible("PL05");
  }
  static PackingListPickTicketReport_IsAccessible() {
    return this.isAccessible("PL06");
  }
  static PackingListMail_IsAccessible() {
    return this.isAccessible("PL07");
  }
  static PackingListReport_IsAccessible() {
    return this.isAccessible("PL08");
  }
  //#endregion

  //#region	PeriodSalesCommission
  static PeriodSalesCommission_IsAccessible() {
    return this.isAccessible("PSC001");
  }
  static PeriodSalesCommissionCreate_IsAccessible() {
    return this.isAccessible("PSC002");
  }
  static PeriodSalesCommissionEdit_IsAccessible() {
    return this.isAccessible("PSC003");
  }
  static PeriodSalesCommissionView_IsAccessible() {
    return this.isAccessible("PSC004");
  }
  static PeriodSalesCommissionCancel_IsAccessible() {
    return this.isAccessible("PSC005");
  }
  static PeriodSalesCommissionApproval_IsAccessible() {
    return this.isAccessible("PSC006");
  }
  //#endregion

  //#region	GroupPurchaseOrderMaintenance
  static GroupPurchaseOrderMaintenance_IsAccessible() {
    return this.isAccessible("GPO00");
  }
  static GroupPurchaseOrderMaintenanceCreate_IsAccessible() {
    return this.isAccessible("GPO01");
  }
  static GroupPurchaseOrderMaintenanceEdit_IsAccessible() {
    return this.isAccessible("GPO02");
  }
  static GroupPurchaseOrderMaintenanceView_IsAccessible() {
    return this.isAccessible("GPO03");
  }
  static GroupPurchaseOrderMaintenanceApprove_IsAccessible() {
    return this.isAccessible("GPO04");
  }
  static GroupPurchaseOrderMaintenanceUnApprove_IsAccessible() {
    return this.isAccessible("GPO05");
  }
  //#endregion

  //#region	AccountPayable
  static AccountPayable_IsAccessible() {
    return this.isAccessible("TAP00");
  }
  static AccountPayableCreate_IsAccessible() {
    return this.isAccessible("TAP01");
  }
  static AccountPayableEdit_IsAccessible() {
    return this.isAccessible("TAP02");
  }
  static AccountPayableView_IsAccessible() {
    return this.isAccessible("TAP03");
  }
  static AccountPayableApprove_IsAccessible() {
    return this.isAccessible("TAP04");
  }
  static AccountPayableCancel_IsAccessible() {
    return this.isAccessible("TAP05");
  }
  static AccountPayableReverse_IsAccessible() {
    return this.isAccessible("TAP06");
  }
  static AccountPayablePDFReport_IsAccessible() {
    return this.isAccessible("TAP07");
  }
  static AccountPayableExcelReport_IsAccessible() {
    return this.isAccessible("TAP08");
  }
  static AccountPayableSendReport_IsAccessible() {
    return this.isAccessible("TAP09");
  }
  //#endregion

  //#region	CustomerTender
  static CustomerTender_IsAccessible() {
    return this.isAccessible("CTA00");
  }
  static CustomerTenderCreate_IsAccessible() {
    return this.isAccessible("CTA01");
  }
  static CustomerTenderEdit_IsAccessible() {
    return this.isAccessible("CTA02");
  }
  static CustomerTenderView_IsAccessible() {
    return this.isAccessible("CTA03");
  }
  static CustomerTenderApprove_IsAccessible() {
    return this.isAccessible("CTA04");
  }
  static CustomerTenderUnapprove_IsAccessible() {
    return this.isAccessible("CTA05");
  }
  static CustomerTenderCancel_IsAccessible() {
    return this.isAccessible("CTA06");
  }
  static CustomerTenderDelete_IsAccessible() {
    return this.isAccessible("CTA07");
  }
  static CustomerTenderPDFReport_IsAccessible() {
    return this.isAccessible("CTA08");
  }
  static CustomerTenderExcelReport_IsAccessible() {
    return this.isAccessible("CTA09");
  }
  static CustomerTenderSendReport_IsAccessible() {
    return this.isAccessible("CTA10");
  }
  //#endregion

  //#region	CustomerPaymentAgingHistoryInquiry
  static CustomerPaymentAgingHistoryInquiry_IsAccessible() {
    return this.isAccessible("IN0400");
  }
  static CustomerPaymentAgingHistoryInquiryPDFReport_IsAccessible() {
    return this.isAccessible("IN0401");
  }
  static CustomerPaymentAgingHistoryInquiryExcelReport_IsAccessible() {
    return this.isAccessible("IN0402");
  }
  static CustomerPaymentAgingHistoryInquiryMailReport_IsAccessible() {
    return this.isAccessible("IN0403");
  }
  //#endregion

  //#region	PatternTypeCategory
  static PatternTypeCategory_IsAccessible() {
    return this.isAccessible("M5220");
  }
  static PatternTypeCategoryCreate_IsAccessible() {
    return this.isAccessible("M5221");
  }
  static PatternTypeCategoryEdit_IsAccessible() {
    return this.isAccessible("M5222");
  }
  static PatternTypeCategoryView_IsAccessible() {
    return this.isAccessible("M5223");
  }
  static PatternTypeCategoryDeletion_IsAccessible() {
    return this.isAccessible("M5224");
  }
  //#endregion

  //#region	ExternalCustomerType
  static ExternalCustomerType_IsAccessible() {
    return this.isAccessible("MEC00");
  }
  static ExternalCustomerTypeCreate_IsAccessible() {
    return this.isAccessible("MEC01");
  }
  static ExternalCustomerTypeEdit_IsAccessible() {
    return this.isAccessible("MEC02");
  }
  static ExternalCustomerTypeView_IsAccessible() {
    return this.isAccessible("MEC03");
  }
  static ExternalCustomerTypeDeletion_IsAccessible() {
    return this.isAccessible("MEC04");
  }
  //#endregion

  //#region	FabricInfoInquiry
  static FabricInfoInquiry_IsAccessible() {
    return this.isAccessible("INFI00");
  }
  static FabricInfoInquiryPDFReport_IsAccessible() {
    return this.isAccessible("INFI01");
  }
  static FabricInfoInquiryExcelReport_IsAccessible() {
    return this.isAccessible("INFI02");
  }
  static FabricInfoInquiryMailReport_IsAccessible() {
    return this.isAccessible("INFI03");
  }
  //#endregion

  //#region	StyleType
  static StyleType_IsAccessible() {
    return this.isAccessible("MSTY00");
  }
  static StyleTypeCreate_IsAccessible() {
    return this.isAccessible("MSTY01");
  }
  static StyleTypeEdit_IsAccessible() {
    return this.isAccessible("MSTY02");
  }
  static StyleTypeView_IsAccessible() {
    return this.isAccessible("MSTY03");
  }
  static StyleTypeDeletion_IsAccessible() {
    return this.isAccessible("MSTY04");
  }
  //#endregion

  //#region	Content
  static Content_IsAccessible() {
    return this.isAccessible("MCNT00");
  }
  static ContentCreate_IsAccessible() {
    return this.isAccessible("MCNT01");
  }
  static ContentEdit_IsAccessible() {
    return this.isAccessible("MCNT02");
  }
  static ContentView_IsAccessible() {
    return this.isAccessible("MCNT03");
  }
  static ContentDelete_IsAccessible() {
    return this.isAccessible("MCNT04");
  }
  //#endregion

  //#region	ItemExport
  static ItemExport_IsAccessible() {
    return this.isAccessible("IE00");
  }

  //#endregion

  //#region	CustomerFabricMapping
  static CustomerFabricMapping_IsAccessible() {
    return this.isAccessible("CFM00");
  }
  static CustomerFabricMappingCreate_IsAccessible() {
    return this.isAccessible("CFM01");
  }
  static CustomerFabricMappingEdit_IsAccessible() {
    return this.isAccessible("CFM02");
  }
  static CustomerFabricMappingView_IsAccessible() {
    return this.isAccessible("CFM03");
  }
  static CustomerFabricMappingDelete_IsAccessible() {
    return this.isAccessible("CFM04");
  }
  //#endregion

  //#region	DataImportFileUpload
  static DataImportFileUpload_IsAccessible() {
    return this.isAccessible("DIFU00");
  }
  static DataImportFileUploadCreate_IsAccessible() {
    return this.isAccessible("DIFU01");
  }
  static DataImportFileUploadEdit_IsAccessible() {
    return this.isAccessible("DIFU02");
  }
  static DataImportFileUploadView_IsAccessible() {
    return this.isAccessible("DIFU03");
  }
  static DataImportFileUploadDelete_IsAccessible() {
    return this.isAccessible("DIFU04");
  }
  //#endregion

  //#region	SKUInventoryProcessSummaryTrack
  static SKUInventoryProcessSummaryTrack_IsAccessible() {
    return this.isAccessible("ISIPST00");
  }
  static SKUInventoryProcessSummaryTrackPDFReport_IsAccessible() {
    return this.isAccessible("ISIPST01");
  }
  static SKUInventoryProcessSummaryTrackExcelReport_IsAccessible() {
    return this.isAccessible("ISIPST02");
  }
  static SKUInventoryProcessSummaryTrackMailReport_IsAccessible() {
    return this.isAccessible("ISIPST03");
  }
  //#endregion

  //#region	PreProductionUnApprovalReason
  static PreProductionUnApprovalReason_IsAccessible() {
    return this.isAccessible("PPUAR00");
  }
  static PreProductionUnApprovalReasonCreate_IsAccessible() {
    return this.isAccessible("PPUAR01");
  }
  static PreProductionUnApprovalReasonEdit_IsAccessible() {
    return this.isAccessible("PPUAR02");
  }
  static PreProductionUnApprovalReasonView_IsAccessible() {
    return this.isAccessible("PPUAR03");
  }
  static PreProductionUnApprovalReasonDelete_IsAccessible() {
    return this.isAccessible("PPUAR04");
  }
  //#endregion

  //#region	PreProductionCancelReason
  static PreProductionCancelReason_IsAccessible() {
    return this.isAccessible("PPCR00");
  }
  static PreProductionCancelReasonCreate_IsAccessible() {
    return this.isAccessible("PPCR01");
  }
  static PreProductionCancelReasonEdit_IsAccessible() {
    return this.isAccessible("PPCR02");
  }
  static PreProductionCancelReasonView_IsAccessible() {
    return this.isAccessible("PPCR03");
  }
  static PreProductionCancelReasonDelete_IsAccessible() {
    return this.isAccessible("PPCR04");
  }
  //#endregion

  //#region	ItemSkuInventoryDetails
  static ItemSkuInventoryDetails_IsAccessible() {
    return this.isAccessible("ISID00");
  }
  static ItemSkuInventoryDetailsPDFReport_IsAccessible() {
    return this.isAccessible("ISID01");
  }
  static ItemSkuInventoryDetailsExcelReport_IsAccessible() {
    return this.isAccessible("ISID02");
  }
  //#endregion
  
 //#region	PurchaseOrderSummary
  static PurchaseOrderSummaryInfoInquiry_IsAccessible() {
    return this.isAccessible("INSPORI00");
  }
  static PurchaseOrderSummaryInfoPDFReport_IsAccessible() {
    return this.isAccessible("INSPORI01");
  }
  static PurchaseOrderSummaryInfoExcelReport_IsAccessible() {
    return this.isAccessible("INSPORI02");
  }
  static PurchaseOrderSummaryInfoMailReport_IsAccessible() {
    return this.isAccessible("INSPORI03");
  }
  //#endregion

  //#region	SalesOrderSummary
  static SalesOrderSummaryInfoInquiry_IsAccessible() {
    return this.isAccessible("INSSORI00");
  }
  static SalesOrderSummaryInfoPDFReport_IsAccessible() {
    return this.isAccessible("INSSORI01");
  }
  static SalesOrderSummaryInfoExcelReport_IsAccessible() {
    return this.isAccessible("INSSORI02");
  }
  static SalesOrderSummaryInfoMailReport_IsAccessible() {
    return this.isAccessible("INSSORI03");
  }
  //#endregion

  //#region	PickTicketSummary
  static PickTicketSummaryInfoInquiry_IsAccessible() {
    return this.isAccessible("INSPTRI00");
  }
  static PickTicketSummaryInfoPDFReport_IsAccessible() {
    return this.isAccessible("INSPTRI01");
  }
  static PickTicketSummaryInfoExcelReport_IsAccessible() {
    return this.isAccessible("INSPTRI02");
  }
  static PickTicketSummaryInfoMailReport_IsAccessible() {
    return this.isAccessible("INSPTRI03");
  }
  //#endregion

  //#region	PurchaseOrderReceiptSummary
  static PurchaseOrderReceiptSummaryInfoInquiry_IsAccessible() {
    return this.isAccessible("INSPORRI00");
  }
  static PurchaseOrderReceiptSummaryInfoPDFReport_IsAccessible() {
    return this.isAccessible("INSPORRI01");
  }
  static PurchaseOrderReceiptSummaryInfoExcelReport_IsAccessible() {
    return this.isAccessible("INSPORRI02");
  }
  static PurchaseOrderReceiptSummaryInfoMailReport_IsAccessible() {
    return this.isAccessible("INSPORRI03");
  }
  //#endregion
  
   //#region	InvoiceSummary
  static InvoiceSummaryInfoInquiry_IsAccessible() {
    return this.isAccessible("INSINVRI00");
  }
  static InvoiceSummaryInfoPDFReport_IsAccessible() {
    return this.isAccessible("INSINVRI01");
  }
  static InvoiceSummaryInfoExcelReport_IsAccessible() {
    return this.isAccessible("INSINVRI02");
  }
  static InvoiceSummaryInfoMailReport_IsAccessible() {
    return this.isAccessible("INSINVRI03");
  }
  //#endregion

   //#region	CreditMemoSummary
  static CreditMemoSummaryInfoInquiry_IsAccessible() {
    return this.isAccessible("INSCMRI00");
  }
  static CreditMemoSummaryInfoPDFReport_IsAccessible() {
    return this.isAccessible("INSCMRI01");
  }
  static CreditMemoSummaryInfoExcelReport_IsAccessible() {
    return this.isAccessible("INSCMRI02");
  }
  static CreditMemoSummaryInfoMailReport_IsAccessible() {
    return this.isAccessible("INSCMRI03");
  }
  //#endregion
  
	static PickTicketCancelReasonMaintenance_IsAccessible() {
			return this.isAccessible("PKC000");
		}
	static PickTicketCancelReasonCreate_IsAccessible() {
			return this.isAccessible("PKC001");
		}
	static PickTicketCancelReasonEdit_IsAccessible() {
			return this.isAccessible("PKC002");
		}
		static PickTicketCancelReasonView_IsAccessible() {
			return this.isAccessible("PKC003");
		}	
	static PickTicketCancelReasonDelete_IsAccessible() {
			return this.isAccessible("PKC004");
		}	
		
 //#region InvoiceModel Attribute
  static InvoiceModelMaintenance_IsAccessible() {
    return this.isAccessible("MINM00");
  }
  static InvoiceModelMaintenanceCreate_IsAccessible() {
    return this.isAccessible("MINM01");
  }
  static InvoiceModelMaintenanceEdit_IsAccessible() {
    return this.isAccessible("MINM02");
  }
  static InvoiceModelMaintenanceView_IsAccessible() {
    return this.isAccessible("MINM03");
  }
  static InvoiceModelMaintenanceDelete_IsAccessible() {
    return this.isAccessible("MINM04");
  }
  //#endregion		
  
  
    static AllFabricsAtsInquiry_IsAccessible() {
    return this.isAccessible("IN0010");
  }


  static SavePortal_IsAccessible() {
    return this.isAccessible("SP01");
  }
  
  static FabricStyleStatistics_IsAccessible() {
    return this.isAccessible("FSCM00");
  }
  
  static FabricCatalog_IsAccessible() {
    return true;
  }
  
  static SalesYearly_IsAccessible() {
    return true;
  }  

  
}
